(function () {
  'use strict';

  var STORE_KEY = '__FDBuildBoxGroups';
  if (!window[STORE_KEY]) window[STORE_KEY] = {};

  var LOCK_SVG =
    '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" aria-hidden="true">' +
    '<path d="M9 33C8.175 33 7.46875 32.7063 6.88125 32.1188C6.29375 31.5313 6 30.825 6 30V15C6 14.175 6.29375 13.4688 6.88125 12.8813C7.46875 12.2938 8.175 12 9 12H10.5V9C10.5 6.925 11.2313 5.15625 12.6938 3.69375C14.1563 2.23125 15.925 1.5 18 1.5C20.075 1.5 21.8438 2.23125 23.3063 3.69375C24.7688 5.15625 25.5 6.925 25.5 9V12H27C27.825 12 28.5313 12.2938 29.1188 12.8813C29.7063 13.4688 30 14.175 30 15V30C30 30.825 29.7063 31.5313 29.1188 32.1188C28.5313 32.7063 27.825 33 27 33H9ZM20.1188 24.6188C20.7063 24.0313 21 23.325 21 22.5C21 21.675 20.7063 20.9688 20.1188 20.3813C19.5313 19.7938 18.825 19.5 18 19.5C17.175 19.5 16.4688 19.7938 15.8813 20.3813C15.2938 20.9688 15 21.675 15 22.5C15 23.325 15.2938 24.0313 15.8813 24.6188C16.4688 25.2063 17.175 25.5 18 25.5C18.825 25.5 19.5313 25.2063 20.1188 24.6188ZM13.5 12H22.5V9C22.5 7.75 22.0625 6.6875 21.1875 5.8125C20.3125 4.9375 19.25 4.5 18 4.5C16.75 4.5 15.6875 4.9375 14.8125 5.8125C13.9375 6.6875 13.5 7.75 13.5 9V12Z" fill="#2C3D50"/></svg>';

  var CHECK_SVG =
    '<svg class="fd-build-box__check-icon" width="24" height="24" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<circle cx="10" cy="10" r="10" fill="#fff"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM14.3652 5.95378C14.1224 5.95214 13.8885 6.04511 13.7126 6.21256C13.7037 6.22126 13.696 6.23061 13.6882 6.24023L9.34733 11.7708L6.73014 9.15527C6.64432 9.06316 6.54078 8.98841 6.42578 8.93717C6.31099 8.88605 6.18684 8.85971 6.0612 8.85742C5.93552 8.8552 5.80994 8.87715 5.69336 8.92415C5.57662 8.9713 5.46988 9.04184 5.38086 9.13086C5.29184 9.21988 5.2213 9.32662 5.17415 9.44336C5.12715 9.55994 5.1052 9.68552 5.10742 9.8112C5.10971 9.93684 5.13605 10.061 5.18717 10.1758C5.23841 10.2908 5.31316 10.3943 5.40527 10.4801L8.71256 13.7874C8.80169 13.8766 8.90818 13.947 9.02506 13.9941C9.14185 14.0412 9.26701 14.0648 9.3929 14.0625C9.5186 14.0602 9.64267 14.0323 9.75749 13.9811C9.8723 13.9298 9.9762 13.8551 10.0618 13.763L15.0505 7.52441C15.2144 7.3453 15.3026 7.1096 15.2962 6.86686C15.2898 6.62399 15.1896 6.39258 15.0163 6.22233C14.8427 6.05205 14.6083 5.95562 14.3652 5.95378Z" fill="#078942"/>' +
    '</svg>';

  var PLUS_SVG =
    '<svg class="fd-build-box-popup__add-icon" width="14" height="14" viewBox="0 0 11.4389 11.4389" fill="none" aria-hidden="true">' +
    '<path d="M5.71973 0.25C6.04805 0.250146 6.31445 0.516373 6.31445 0.844727V5.125H10.5947C10.923 5.12526 11.1885 5.39144 11.1885 5.71973C11.1883 6.04784 10.9229 6.3142 10.5947 6.31445H6.31445V10.5947C6.31418 10.9228 6.04791 11.1883 5.71973 11.1885C5.39142 11.1885 5.12528 10.9229 5.125 10.5947V6.31445H0.844727C0.516351 6.31445 0.250166 6.04799 0.25 5.71973L0.261719 5.59961C0.317136 5.32858 0.557311 5.125 0.844727 5.125H5.125V0.844727C5.125 0.516283 5.39128 0.25 5.71973 0.25Z" fill="currentColor" stroke="currentColor" stroke-width="0.5" stroke-linecap="round"/></svg>';

  var MINUS_SVG =
    '<svg class="fd-build-box-popup__step-icon" width="14" height="14" viewBox="0 0 11.4389 1.68933" fill="none" aria-hidden="true">' +
    '<path d="M10.5947 0.25C10.923 0.250258 11.1885 0.516442 11.1885 0.844727C11.1884 1.17293 10.923 1.4392 10.5947 1.43945H0.844727C0.516282 1.43945 0.250054 1.17309 0.25 0.844727C0.25 0.516283 0.516283 0.25 0.844727 0.25H10.5947Z" fill="currentColor" stroke="currentColor" stroke-width="0.5" stroke-linecap="round"/></svg>';

  var INFO_SVG =
    '<svg class="fd-build-box-popup__card-info-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="8" fill="#2C3D50"/>' +
    '<circle cx="8" cy="5.1" r="1.05" fill="#fff"/>' +
    '<rect x="7.15" y="7.05" width="1.7" height="5.2" rx="0.85" fill="#fff"/>' +
    '</svg>';

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function getThemeDiscount() {
    var o = (typeof window !== 'undefined' && window.__pdpDiscountOverride) || null;
    if (!o) {
      return { otpMult: 1, subMult: 1, otpPct: null, subPct: null, otpCode: '', subCode: '' };
    }
    var otpPct = Number.isFinite(o.discountPercent) ? o.discountPercent : null;
    var subPct = Number.isFinite(o.subDiscountPercent) ? o.subDiscountPercent : otpPct;
    return {
      otpMult: otpPct != null ? (100 - otpPct) / 100 : 1,
      subMult: subPct != null ? (100 - subPct) / 100 : 1,
      otpPct: otpPct,
      subPct: subPct,
      otpCode: String(o.otpCouponCode || o.couponCode || '').trim(),
      subCode: String(o.couponCode || '').trim(),
    };
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function attr(name, value) {
    if (value == null || value === '') return '';
    return ' ' + name + '="' + escapeHtml(String(value)) + '"';
  }

  function infoModalAttrs(handle, label, noCta) {
    if (!handle) return '';
    return attr('data-info-modal-open', handle) + attr('aria-label', label) + (noCta ? attr('data-info-modal-cta', 'false') : '');
  }

  var MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function dayOrdinal(n) {
    var v = n % 100;
    if (v >= 11 && v <= 13) return n + 'th';
    switch (n % 10) {
      case 1:
        return n + 'st';
      case 2:
        return n + 'nd';
      case 3:
        return n + 'rd';
      default:
        return n + 'th';
    }
  }

  function formatPromoDate(now) {
    now = now || new Date();
    return MONTHS_SHORT[now.getMonth()] + ' ' + dayOrdinal(now.getDate());
  }

  function applyDateTokens(root) {
    var date = formatPromoDate();
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.fd-build-box__promo-text, .fd-build-box__after-gifts');
    Array.prototype.forEach.call(nodes, function (el) {
      var src = el.getAttribute('data-fd-date-src');
      if (src == null) {
        src = el.innerHTML;
        el.setAttribute('data-fd-date-src', src);
      }
      if (!/\{date\}/i.test(src)) return;
      el.innerHTML = src.replace(/\{date\}/gi, date);
    });
  }

  function normalizeHex(value) {
    var hex = String(value || '').trim();
    if (/^#([0-9A-Fa-f]{8})$/.test(hex)) hex = '#' + hex.slice(1, 7);
    if (/^#([0-9A-Fa-f]{6})$/.test(hex)) return hex;
    return '';
  }

  function badgeStyleAttr(bg, fg) {
    var parts = [];
    var solid = normalizeHex(bg);
    var text = normalizeHex(fg);
    if (solid) parts.push('--fd-bb-card-badge-solid:' + solid);
    if (text) parts.push('--fd-bb-card-badge-fg:' + text);
    if (!parts.length) return '';
    return ' style="' + parts.join(';') + '"';
  }

  function collectDealCounts(dealEls) {
    var counts = [];
    Array.prototype.forEach.call(dealEls || [], function (el) {
      var c = parseInt(el.getAttribute('data-deal-count'), 10) || 0;
      if (c > 0 && counts.indexOf(c) === -1) counts.push(c);
    });
    counts.sort(function (a, b) {
      return a - b;
    });
    return counts;
  }

  function earnedGiftTier(dealCounts, filled) {
    var earned = 0;
    var n = Number(filled) || 0;
    (dealCounts || []).forEach(function (c) {
      if (c <= n && c > earned) earned = c;
    });
    return earned;
  }

  function normalizeTiers(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
      .map(function (t) {
        return {
          qty: parseInt(t && t.qty, 10) || 0,
          percent: parseFloat(t && t.percent),
          otpPercent: parseFloat(t && t.otpPercent),
          label: (t && t.label) || '',
        };
      })
      .filter(function (t) {
        return t.qty > 0 && isFinite(t.percent);
      })
      .sort(function (a, b) {
        return a.qty - b.qty;
      });
  }

  function currentTier(tiers, qty) {
    var found = null;
    (tiers || []).forEach(function (t) {
      if (t.qty <= qty && (!found || t.qty > found.qty)) found = t;
    });
    return found;
  }

  /* Percent off list for a box of `qty` bottles, in the current purchase mode. Mirrors what
     checkout code BUNDLEBUILDER charges by bottle count, so it never reads the step-1 pack. */
  function tierPercentFor(tiers, qty, subscribe) {
    var tier = currentTier(tiers, qty);
    if (!tier) return 0;
    var pct = subscribe ? tier.percent : tier.otpPercent;
    return isFinite(pct) ? pct : 0;
  }

  function nextTierFor(tiers, qty, subscribe) {
    var now = tierPercentFor(tiers, qty, subscribe);
    var found = null;
    (tiers || []).forEach(function (t) {
      if (found || t.qty <= qty) return;
      var pct = subscribe ? t.percent : t.otpPercent;
      if (isFinite(pct) && pct > now) found = { qty: t.qty, percent: pct };
    });
    return found;
  }

  function discountedCents(listCents, pct) {
    return Math.round(((Number(listCents) || 0) * (100 - (Number(pct) || 0))) / 100);
  }

  function giftValueCents(gifts, count) {
    return (gifts || []).slice(0, count).reduce(function (sum, gift) {
      var n = parseFloat(String((gift && gift.price) || '').replace(/[$,\s]/g, ''));
      return sum + (isFinite(n) && n > 0 ? Math.round(n * 100) : 0);
    }, 0);
  }

  /* Whole % saved vs list plus gift value. Same rounding as snippets/fd-build-box-savings-pct. */
  function savedPercent(paidCents, fullCents) {
    return fullCents > 0 && paidCents < fullCents ? Math.floor(((fullCents - paidCents) * 100) / fullCents) : 0;
  }

  function uniqueId() {
    return 'bundle-' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function pageHandleFromUrl() {
    var path = String((window.location && window.location.pathname) || '');
    var match = path.match(/\/(?:pages|products)\/([^/?#]+)/i);
    var handle = match && match[1] ? decodeURIComponent(match[1]) : '';
    if (!handle) {
      var parts = path.replace(/\/+$/, '').split('/').filter(Boolean);
      handle = parts.length ? decodeURIComponent(parts[parts.length - 1]) : '';
    }
    return String(handle)
      .toLowerCase()
      .replace(/[^\w-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function stampBundleProps(props, bundleId, title, parentPdpId, parentPdpHandle) {
    props._bundle = bundleId;
    props._bundle_title = title;
    var handle = pageHandleFromUrl();
    if (handle) props['_bundle-page'] = handle;
    if (parentPdpId) props._parent_pdp = String(parentPdpId);
    if (parentPdpHandle) props._parent_pdp_handle = String(parentPdpHandle);
    return props;
  }

  function openCartDrawer() {
    var btn = document.querySelector('.js-menu__open[data-menu="#main-nav"]');
    var menu = document.querySelector('#main-nav');
    if (btn && menu && !menu.classList.contains('is-active') && !menu.classList.contains('active')) {
      btn.click();
      return;
    }
    if (menu) {
      menu.classList.add('is-active', 'active');
      document.documentElement.classList.add('overflow-hidden');
    }
  }

  function noop() {}

  function whenIdle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 1500 });
    } else {
      setTimeout(fn, 200);
    }
  }

  // ---- Cart helpers for the after_add = drawer flow ----------------------------

  function readCart() {
    if (window.FDCartApi && typeof window.FDCartApi.getCart === 'function') {
      return window.FDCartApi.getCart(true);
    }
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
      function (res) {
        if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
        return res.json();
      }
    );
  }

  // POST /cart/update.js; resolves with the updated cart JSON.
  function writeCart(payload) {
    if (window.FDCartApi && typeof window.FDCartApi.updateCart === 'function') {
      return window.FDCartApi.updateCart(payload);
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart update failed: ' + res.status);
      return res.json();
    });
  }

  function upperCode(code) {
    return String(code == null ? '' : code)
      .trim()
      .toUpperCase();
  }

  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || [])
      .map(function (entry) {
        return entry && entry.code;
      })
      .filter(Boolean);
  }

  function hasCode(list, code) {
    var key = upperCode(code);
    return (list || []).some(function (c) {
      return upperCode(c) === key;
    });
  }

  function hasAllCodes(cart, codes) {
    var have = cartCodes(cart);
    return codes.every(function (code) {
      return hasCode(have, code);
    });
  }

  // existing + add, deduped case-insensitively, existing order first.
  function mergeCodes(existing, add) {
    var out = [];
    (existing || []).concat(add || []).forEach(function (raw) {
      var code = String(raw == null ? '' : raw).trim();
      if (code && !hasCode(out, code)) out.push(code);
    });
    return out;
  }

  function isGiftProps(props) {
    props = props || {};
    return props._bundle_gift === 'true' || props._free_gift === 'true';
  }

  function cartHasPaidLines(cart) {
    return ((cart && cart.items) || []).some(function (item) {
      return !isGiftProps(item.properties) && Number(item.original_line_price) > 0;
    });
  }

  // Same values the add-to-cart handler writes after an add.
  function subscriptionAttributes(subscribe) {
    return subscribe
      ? { _is_subscription_purchase: 'true', _is_one_time_purchase: '' }
      : { _is_one_time_purchase: 'true', _is_subscription_purchase: '' };
  }

  function cartDisplayFn() {
    return typeof updateCartDisplay === 'function' ? updateCartDisplay : window.updateCartDisplay;
  }

  // While the box is being added, the drawer skips its lazy first render of the old
  // cart (ensureCartRenderedIfNeeded), which competes with the add and could paint
  // over the box. Expires on its own.
  var CART_RENDER_HOLD_MS = 12000;

  function holdCartRenders(on) {
    window.__fdCartRenderHold = on ? { until: Date.now() + CART_RENDER_HOLD_MS } : null;
  }

  // Performance marks for "Shop Now to confirmed cart"; readable in RUM tools.
  function markCartTiming(name, startName) {
    try {
      if (window.performance && typeof performance.mark === 'function') {
        performance.mark(name);
        if (startName) performance.measure('fd-bb:shop-now-to-cart-confirmed', startName, name);
      }
    } catch (e) {}
    return name;
  }

  // Warm what the add and the cart drawer ask for, per product: the add handler's
  // variant lookup, the product JSON behind the drawer's tag checks (filled into
  // PBFCM_PRODUCT_DATA, same shape as the product card snippets), and for lines the
  // drawer renders on their own (gifts) the reviews badge and blurb queries.
  var warmedHandles = Object.create(null);
  // Product titles from the same JSON, so the loading state names lines exactly as
  // the cart will (the cart shows product titles, not the builder's short labels).
  var warmedTitles = Object.create(null);

  function warmProductForCart(handle, variantId, lineDetails) {
    if (!handle || warmedHandles[handle]) return;
    warmedHandles[handle] = true;

    var known = window.PBFCM_PRODUCT_DATA && window.PBFCM_PRODUCT_DATA[handle];
    var ready =
      known && known.id
        ? Promise.resolve(known)
        : fetch('/products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          })
            .then(function (res) {
              return res.ok ? res.json() : null;
            })
            .then(function (product) {
              if (!product || !product.handle) return null;
              if (product.title) warmedTitles[handle] = product.title;
              var tags = Array.isArray(product.tags) ? product.tags : [];
              var data = {
                id: product.id,
                handle: product.handle,
                tags: tags,
                hasTNProduct: tags.indexOf('TNProduct') !== -1,
              };
              window.PBFCM_PRODUCT_DATA = window.PBFCM_PRODUCT_DATA || {};
              if (!window.PBFCM_PRODUCT_DATA[product.handle]) window.PBFCM_PRODUCT_DATA[product.handle] = data;
              return data;
            });

    if (!lineDetails) {
      ready.catch(noop);
      return;
    }
    ready
      .then(function (data) {
        var sf = window.Storefront;
        if (!data || !data.id || !sf) return;
        if (typeof sf.productReviewsById === 'function') sf.productReviewsById(data.id).catch(noop);
        if (typeof sf.productBlurbById === 'function') sf.productBlurbById(data.id).catch(noop);
      })
      .catch(noop);
  }

  // ---- Cart drawer loading state ---------------------------------------------

  var CART_STATUS_COPY = {
    adding: 'Adding your box to the cart…',
    pricing: 'Applying your bundle savings…',
  };

  function skeletonPriceBlock() {
    return '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__price"></span>';
  }

  function skeletonMedia(image) {
    if (!image) return '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__media"></span>';
    return (
      '<span class="fd-bb-cart-skeleton__media fd-bb-cart-skeleton__media--image">' +
      '<img src="' + escapeHtml(image) + '" alt="" width="64" height="64">' +
      '</span>'
    );
  }

  function skeletonGenericRow() {
    return (
      '<div class="fd-bb-cart-skeleton__row">' +
      skeletonMedia('') +
      '<span class="fd-bb-cart-skeleton__lines">' +
      '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar"></span>' +
      '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar fd-bb-cart-skeleton__bar--short"></span>' +
      '</span>' +
      skeletonPriceBlock() +
      '</div>'
    );
  }

  // `preview` (from cartPreview) draws the real box and gifts; a number draws that
  // many placeholder rows. Prices and the total always stay placeholders here.
  function showCartSkeleton(preview) {
    hideCartSkeleton();
    var nav = document.getElementById('main-nav');
    var body = document.querySelector('#main-nav .firstday-cart__flyout-body');
    if (!body) return;

    var rows = '';
    if (preview && typeof preview === 'object') {
      rows +=
        '<div class="fd-bb-cart-skeleton__row fd-bb-cart-skeleton__row--box">' +
        skeletonMedia(preview.image) +
        '<span class="fd-bb-cart-skeleton__lines">' +
        '<span class="fd-bb-cart-skeleton__title">' + escapeHtml(preview.title) + '</span>' +
        (preview.contents || [])
          .map(function (line) {
            return '<span class="fd-bb-cart-skeleton__meta">' + escapeHtml(line) + '</span>';
          })
          .join('') +
        '</span>' +
        skeletonPriceBlock() +
        '</div>';
      (preview.gifts || []).forEach(function (gift) {
        rows +=
          '<div class="fd-bb-cart-skeleton__row">' +
          skeletonMedia(gift.image) +
          '<span class="fd-bb-cart-skeleton__lines">' +
          (gift.title
            ? '<span class="fd-bb-cart-skeleton__title">' + escapeHtml(gift.title) + '</span>'
            : '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar"></span>') +
          '</span>' +
          skeletonPriceBlock() +
          '</div>';
      });
    } else {
      var n = Math.max(2, Math.min(Number(preview) || 3, 5));
      for (var i = 0; i < n; i++) rows += skeletonGenericRow();
    }

    var el = document.createElement('div');
    el.className = 'fd-bb-cart-skeleton';
    // Placeholders are hidden from screen readers; the status line is announced.
    el.innerHTML =
      '<div class="fd-bb-cart-skeleton__status" role="status" aria-live="polite">' +
      '<span class="fd-bb-cart-skeleton__spinner" aria-hidden="true"></span>' +
      '<span data-fd-bb-cart-status>' + CART_STATUS_COPY.adding + '</span>' +
      '</div>' +
      '<div class="fd-bb-cart-skeleton__rows" aria-hidden="true">' +
      rows +
      '<div class="fd-bb-cart-skeleton__total">' +
      '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar"></span>' +
      '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar fd-bb-cart-skeleton__bar--short"></span>' +
      '</div>' +
      '</div>';
    body.classList.add('fd-bb-cart-skeleton-host');
    body.appendChild(el);

    // Footer: the old total stays hidden and checkout stays locked until the
    // confirmed cart is painted.
    if (nav) nav.classList.add('fd-bb-cart-pending');
    var checkout = document.getElementById('checkoutButton');
    if (checkout) {
      checkout.setAttribute('data-fd-bb-was-disabled', checkout.disabled ? 'true' : 'false');
      checkout.disabled = true;
      checkout.setAttribute('aria-busy', 'true');
    }
  }

  // updateCartDisplay can hand off to a corrective cart write (a gift rule removing
  // a line) and paint later. Resolve once the drawer shows lines, or after 5s.
  function linesPainted(cart) {
    var form = document.getElementById('mini_cart_form');
    if (!form || !cart || !cart.item_count || form.children.length) return Promise.resolve();
    return new Promise(function (resolve) {
      var done = function () {
        observer.disconnect();
        clearTimeout(timer);
        resolve();
      };
      var observer = new MutationObserver(function () {
        if (form.children.length) done();
      });
      var timer = setTimeout(done, 5000);
      observer.observe(form, { childList: true });
    });
  }

  function setCartSkeletonStatus(step) {
    var label = document.querySelector('.fd-bb-cart-skeleton [data-fd-bb-cart-status]');
    if (label && CART_STATUS_COPY[step]) label.textContent = CART_STATUS_COPY[step];
  }

  function hideCartSkeleton() {
    Array.prototype.forEach.call(document.querySelectorAll('.fd-bb-cart-skeleton'), function (el) {
      if (el.parentNode) el.parentNode.classList.remove('fd-bb-cart-skeleton-host');
      el.remove();
    });
    var nav = document.getElementById('main-nav');
    if (nav) nav.classList.remove('fd-bb-cart-pending');
    var checkout = document.getElementById('checkoutButton');
    if (checkout && checkout.hasAttribute('data-fd-bb-was-disabled')) {
      checkout.disabled = checkout.getAttribute('data-fd-bb-was-disabled') === 'true';
      checkout.removeAttribute('aria-busy');
      checkout.removeAttribute('data-fd-bb-was-disabled');
    }
  }

  function getGroup(groupId) {
    if (!window[STORE_KEY][groupId]) {
      window[STORE_KEY][groupId] = {
        dealId: null,
        count: 1,
        tierPercent: null,
        maxCount: 1,
        dealCounts: [],
        gifts: [],
        heroImage: '',
        dealName: '',
        qty: {},
        productMeta: {},
        subscribe: true,
        listeners: [],
      };
    }
    if (typeof window[STORE_KEY][groupId].subscribe !== 'boolean') {
      window[STORE_KEY][groupId].subscribe = true;
    }
    return window[STORE_KEY][groupId];
  }

  function notify(groupId) {
    var g = getGroup(groupId);
    g.listeners.slice().forEach(function (fn) {
      try {
        fn(g);
      } catch (e) {}
    });
  }

  function onGroupChange(groupId, fn) {
    var g = getGroup(groupId);
    g.listeners.push(fn);
    return function () {
      g.listeners = g.listeners.filter(function (x) {
        return x !== fn;
      });
    };
  }

  function giftPriceText(gift) {
    var rawPrice = gift.price != null && gift.price !== '' ? String(gift.price).trim() : '';
    if (!rawPrice) return '';
    return rawPrice.charAt(0) === '$' ? rawPrice : '$' + rawPrice;
  }

  function giftLabelHtml(gift) {
    var priceText = giftPriceText(gift);
    var price = priceText
      ? '<strong class="fd-build-box__gift-price">' + escapeHtml(priceText) + '</strong> '
      : '';
    var name = escapeHtml(gift.displayName || gift.label || 'Gift');
    return price + name;
  }

  function giftBadgeHtml(gift) {
    var priceText = giftPriceText(gift);
    if (!priceText) return '';
    return (
      '<span class="fd-build-box__gift-badge"><span class="fd-build-box__gift-badge-label">FREE</span><span class="fd-build-box__gift-badge-price">' +
      escapeHtml(priceText) +
      '</span></span>'
    );
  }

  function renderGiftCard(gift, opts) {
    opts = opts || {};
    var locked = !!opts.locked;
    var unlocked = !!opts.unlocked;
    var hideImage = !!opts.hideImage || (locked && !!opts.lockReplacesImage);
    var hideCheck = !!opts.hideCheck;
    var showBadge = !!opts.showBadge;
    var captionNameOnly = !!opts.captionNameOnly;
    var cls = 'fd-build-box__gift';
    if (locked) cls += ' is-locked';
    if (unlocked) cls += ' is-unlocked';
    if (locked && hideImage) cls += ' is-lock-only';
    var img =
      gift.image && !hideImage
        ? '<img src="' + escapeHtml(gift.image) + '" alt="" width="120" height="120" loading="lazy">'
        : '';
    var caption = captionNameOnly
      ? escapeHtml(gift.displayName || gift.label || 'Gift')
      : giftLabelHtml(gift);
    var handle = opts.infoModal ? gift.handle || '' : '';
    var name = gift.displayName || gift.label || 'Gift';
    var openTag = handle
      ? '<button type="button" class="' + cls + '"' + infoModalAttrs(handle, 'More info about ' + name) + '>'
      : '<div class="' + cls + '">';
    return (
      openTag +
      '<div class="fd-build-box__gift-media">' +
      img +
      (showBadge ? giftBadgeHtml(gift) : '') +
      (locked ? '<span class="fd-build-box__gift-lock" aria-hidden="true">' + LOCK_SVG + '</span>' : '') +
      (unlocked && !hideCheck
        ? '<span class="fd-build-box__gift-check" aria-hidden="true">' + CHECK_SVG + '</span>'
        : '') +
      '</div>' +
      '<p class="fd-build-box__gift-label">' +
      caption +
      '</p>' +
      (handle ? '</button>' : '</div>')
    );
  }

  function renderCardPrice(price) {
    if (!price || !(price.list > 0)) return '';
    var sale = price.final < price.list;
    return (
      '<span class="fd-build-box-popup__card-price">' +
      (sale ? '<s class="fd-build-box-popup__card-compare">' + money(price.list) + '</s>' : '') +
      '<span class="fd-build-box-popup__card-final">' +
      money(price.final) +
      '</span>' +
      '</span>'
    );
  }

  function renderProductCard(p, qty, badges, price, opts) {
    opts = opts || {};
    var compact = !!opts.compact;
    var id = String(p.variantId);
    var badge = p.badge;
    var badgeBg = p.badgeBg;
    var badgeFg = p.badgeFg;
    if (!badge && badges && p.productId != null) {
      var configBadge = badges[String(p.productId)];
      if (configBadge && configBadge.text) {
        badge = configBadge.text;
        badgeBg = configBadge.bg;
        badgeFg = configBadge.fg;
      }
    }
    if (compact) badge = '';
    var handle = compact ? '' : p.handle || '';
    if (handle && p.productId && window.FDInfoModal && typeof window.FDInfoModal.register === 'function') {
      window.FDInfoModal.register(p.productId, handle);
    }
    var mediaOnly = !!opts.mediaInfo;
    var openInfo = handle && !mediaOnly
      ? '<button type="button" class="fd-build-box-popup__card-info"' +
        infoModalAttrs(handle, 'Product details', opts.hideInfo) +
        '>'
      : '<span class="fd-build-box-popup__card-info">';
    var closeInfo = handle && !mediaOnly ? '</button>' : '</span>';
    var media =
      p.image && !compact
        ? '<span class="fd-build-box-popup__card-media">' +
          '<img src="' +
          escapeHtml(p.image) +
          '" alt="" width="72" height="72" loading="lazy">' +
          (handle ? INFO_SVG : '') +
          '</span>'
        : '';
    var boxInfo = handle && mediaOnly ? attr('data-box-info', id) + ' aria-haspopup="dialog"' : '';
    if (media && boxInfo) {
      media =
        '<button type="button" class="fd-build-box-popup__card-media-btn"' +
        boxInfo +
        attr('aria-label', 'Product details: ' + (p.title || '')) +
        '>' +
        media +
        '</button>';
    }
    var name = boxInfo
      ? '<button type="button" class="fd-build-box-popup__card-name fd-build-box-popup__card-name-btn"' +
        boxInfo +
        '>' +
        escapeHtml(p.title || '') +
        '</button>'
      : '<span class="fd-build-box-popup__card-name">' + escapeHtml(p.title || '') + '</span>';
    return (
      '<article class="fd-build-box-popup__card' +
      (compact ? ' fd-build-box-popup__card--row' : '') +
      (qty > 0 ? ' is-selected' : '') +
      '" data-product-card data-variant-id="' +
      escapeHtml(id) +
      '" data-title="' +
      escapeHtml(p.title || '') +
      '" data-image="' +
      escapeHtml(p.image || '') +
      '" data-variant-title="' +
      escapeHtml(p.variantTitle || '') +
      '">' +
      openInfo +
      media +
      '<span class="fd-build-box-popup__card-body">' +
      name +
      (p.description && !compact
        ? '<span class="fd-build-box-popup__card-desc">' + escapeHtml(p.description) + '</span>'
        : '') +
      renderCardPrice(price) +
      '</span>' +
      closeInfo +
      (compact
        ? ''
        : '<button type="button" class="fd-build-box-popup__add" data-add data-variant-id="' +
          escapeHtml(id) +
          '">Add ' +
          PLUS_SVG +
          '</button>') +
      '<div class="fd-build-box-popup__stepper">' +
      '<button type="button" class="fd-build-box-popup__step" data-dec data-variant-id="' +
      escapeHtml(id) +
      '" aria-label="Decrease">' +
      MINUS_SVG +
      '</button>' +
      '<span class="fd-build-box-popup__qty">' +
      qty +
      '</span>' +
      '<button type="button" class="fd-build-box-popup__step" data-inc data-variant-id="' +
      escapeHtml(id) +
      '" aria-label="Increase">' +
      PLUS_SVG +
      '</button>' +
      '</div>' +
      (badge
        ? '<span class="fd-build-box-popup__card-badge"' +
          badgeStyleAttr(badgeBg, badgeFg) +
          '>' +
          escapeHtml(badge) +
          '</span>'
        : '') +
      '</article>'
    );
  }

  function FdBuildBoxQty(root) {
    this.root = root;
    this.groupId = root.getAttribute('data-group');
    this.els = {
      deals: root.querySelectorAll('[data-deal-id]'),
      giftsGrid: root.querySelector('[data-gifts-grid]'),
      giftsStatus: root.querySelector('[data-gifts-status]'),
      otpPrice: root.querySelector('[data-otp-price]'),
      otpCopy: root.querySelector('[data-otp-copy]'),
      openPopup: root.querySelector('[data-open-popup]'),
      subscribeToggle: root.querySelector('[data-subscribe-toggle]'),
    };
    this.drawerMode = root.classList.contains('fd-build-box--summary-drawer');
    this.infoModal = !root.hasAttribute('data-hide-product-info');
    var g = getGroup(this.groupId);
    g.subscribe = root.getAttribute('data-subscribe') !== 'false';
    this.syncSubscribeUI();
    this.bind();
    var defaultId = root.getAttribute('data-default-deal');
    var initial = null;
    Array.prototype.forEach.call(this.els.deals, function (btn) {
      if (btn.getAttribute('data-deal-id') === defaultId) initial = btn;
    });
    if (!initial) {
      Array.prototype.forEach.call(this.els.deals, function (btn) {
        if (!initial && !btn.disabled) initial = btn;
      });
    }
    if (initial) this.selectDeal(initial, true);
    else this.updateOtpPrice();
  }

  FdBuildBoxQty.prototype.syncSubscribeUI = function () {
    var g = getGroup(this.groupId);
    var on = g.subscribe !== false;
    this.root.setAttribute('data-subscribe', on ? 'true' : 'false');
    this.root.classList.toggle('is-otp', !on);
    Array.prototype.forEach.call(this.els.deals, function (btn) {
      var pctEl = btn.querySelector('[data-deal-pct]');
      if (!pctEl) return;
      var key = on ? 'tier-percent' : 'otp-percent';
      var pct = parseFloat(btn.getAttribute('data-show-' + key) || btn.getAttribute('data-' + key));
      pctEl.textContent = isFinite(pct) && pct > 0 ? pct + '% OFF' : ' ';
    });
    if (!this.els.subscribeToggle) return;
    this.els.subscribeToggle.classList.toggle('is-on', on);
    var otpLabel = this.root.getAttribute('data-otp-label') || 'One-Time Purchase';
    var subLabel = this.root.getAttribute('data-subscribe-label') || 'Subscribe';
    if (this.els.otpCopy) this.els.otpCopy.textContent = on ? otpLabel : subLabel;
    if (this.els.otpPrice) {
      if (on) this.els.otpPrice.removeAttribute('hidden');
      else this.els.otpPrice.setAttribute('hidden', '');
    }
    this.els.subscribeToggle.setAttribute('aria-pressed', on ? 'false' : 'true');
    this.els.subscribeToggle.setAttribute(
      'aria-label',
      on ? 'Switch to one-time purchase' : 'Switch to subscription'
    );
  };

  FdBuildBoxQty.prototype.setSubscribe = function (on) {
    var g = getGroup(this.groupId);
    g.subscribe = !!on;
    this.root.classList.toggle('is-otp', !g.subscribe);
    this.syncSubscribeUI();
    notify(this.groupId);
  };

  FdBuildBoxQty.prototype.bind = function () {
    var self = this;
    Array.prototype.forEach.call(this.els.deals, function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        self.selectDeal(btn, false);
      });
    });
    if (this.els.subscribeToggle) {
      this.els.subscribeToggle.addEventListener('click', function () {
        var g = getGroup(self.groupId);
        self.setSubscribe(!g.subscribe);
        document.dispatchEvent(
          new CustomEvent('fd-build-box:open', { detail: { groupId: self.groupId } })
        );
      });
    }
    if (this.els.openPopup) {
      this.els.openPopup.addEventListener('click', function () {
        document.dispatchEvent(
          new CustomEvent('fd-build-box:open', { detail: { groupId: self.groupId } })
        );
      });
    }
  };

  FdBuildBoxQty.prototype.readGifts = function (dealId) {
    var script = this.root.querySelector('[data-deal-gifts="' + dealId + '"]');
    if (!script) return [];
    try {
      var list = JSON.parse(script.textContent || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };

  FdBuildBoxQty.prototype.selectDeal = function (btn, silent) {
    var dealId = btn.getAttribute('data-deal-id');
    var count = parseInt(btn.getAttribute('data-deal-count'), 10) || 1;
    var nameEl = btn.querySelector('.fd-build-box__deal-name');
    var heroImage = btn.getAttribute('data-deal-image') || '';

    var dealCounts = collectDealCounts(this.els.deals);
    var maxPack = dealCounts.length ? dealCounts[dealCounts.length - 1] : count;
    var maxDealId = dealId;
    Array.prototype.forEach.call(this.els.deals, function (el) {
      var c = parseInt(el.getAttribute('data-deal-count'), 10) || 0;
      if (c === maxPack) maxDealId = el.getAttribute('data-deal-id') || dealId;
    });

    var gifts = this.readGifts(maxDealId);
    if (!gifts.length) gifts = this.readGifts(dealId);

    Array.prototype.forEach.call(this.els.deals, function (el) {
      var selected = el === btn;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    var tierPercent = parseFloat(btn.getAttribute('data-tier-percent'));

    var g = getGroup(this.groupId);
    g.dealId = dealId;
    g.count = count;
    g.tierPercent = isFinite(tierPercent) ? tierPercent : null;
    g.dealCounts = dealCounts;
    g.maxCount = maxPack || count;
    g.gifts = gifts;
    g.heroImage = heroImage;
    g.dealName = nameEl ? nameEl.textContent.trim() : count + ' Pack';

    var total = this.totalQty(g);

    this.renderGifts(gifts, count, maxPack);
    this.updateOtpPrice();
    notify(this.groupId);
  };

  FdBuildBoxQty.prototype.updateOtpPrice = function () {
    if (!this.els.otpPrice) return;
    var selected = this.root.querySelector('[data-deal-id].is-selected');
    var cents = selected ? parseInt(selected.getAttribute('data-otp-cents'), 10) || 0 : 0;
    this.els.otpPrice.textContent = cents > 0 ? money(cents) : '';
  };

  FdBuildBoxQty.prototype.totalQty = function (g) {
    var t = 0;
    Object.keys(g.qty || {}).forEach(function (id) {
      t += Number(g.qty[id]) || 0;
    });
    return t;
  };

  FdBuildBoxQty.prototype.trimQty = function (g, max) {
    var ids = Object.keys(g.qty);
    var total = this.totalQty(g);
    while (total > max && ids.length) {
      var id = ids[ids.length - 1];
      var q = Number(g.qty[id]) || 0;
      if (q <= 0) {
        ids.pop();
        continue;
      }
      var remove = Math.min(q, total - max);
      g.qty[id] = q - remove;
      if (g.qty[id] <= 0) {
        delete g.qty[id];
        ids.pop();
      }
      total -= remove;
    }
  };

  FdBuildBoxQty.prototype.renderGifts = function (gifts, count, maxPack) {
    var unlockThru = Math.max(0, count || 0);
    var total = maxPack || gifts.length || 0;
    if (this.els.giftsStatus) {
      this.els.giftsStatus.textContent = unlockThru + '/' + total + ' Free Gifts';
    }
    if (!this.els.giftsGrid) return;
    if (!gifts.length) {
      this.els.giftsGrid.innerHTML = '';
      return;
    }
    var drawerMode = this.drawerMode;
    var infoModal = this.infoModal;
    this.els.giftsGrid.innerHTML = gifts
      .map(function (gift, i) {
        var locked = i >= unlockThru;
        return renderGiftCard(gift, {
          locked: locked,
          unlocked: !locked,
          lockReplacesImage: locked && !drawerMode,
          infoModal: infoModal,
          hideCheck: true,
          showBadge: true,
          captionNameOnly: true,
        });
      })
      .join('');
  };

  function FdBuildBoxPopup(root) {
    this.root = root;
    this.groupId = root.getAttribute('data-group');
    this.config = this.readConfig();
    this.state = {
      submitting: false,
      activeCat: null,
      scrollingToCat: false,
      drawerOpen: false,
      sheetOpen: false,
      packTarget: 0,
      submitted: false,
    };
    this._catScrollUnlockTimer = null;
    // after_add = drawer: the cart is prepared while the shopper builds (see primeCart).
    this.fastCart = String(this.config.afterAdd || 'checkout') === 'drawer';
    this.prime = null;
    this._unprimeTimer = null;
    this.els = {
      cats: root.querySelector('[data-cats]'),
      products: root.querySelector('[data-products]'),
      scroll: root.querySelector('[data-scroll]'),
      popupGifts: root.querySelector('[data-popup-gifts]'),
      slots: root.querySelector('[data-slots]'),
      summary: root.querySelector('[data-tier-summary]'),
      tierNext: root.querySelector('[data-tier-next]'),
      boxTotal: root.querySelector('[data-box-total]'),
      checkout: root.querySelector('[data-checkout]'),
      checkoutLabel: root.querySelector('[data-checkout-label]'),
      checkoutArrow: root.querySelector('[data-checkout-arrow]'),
      hero: root.querySelector('[data-popup-hero]'),
      heroImg: root.querySelector('[data-popup-hero-img]'),
      heroCollage: root.querySelector('[data-popup-hero-collage]'),
      closeBtns: root.querySelectorAll('[data-close-popup]'),
      title: root.querySelector('.fd-build-box-popup__title'),
      footer: root.querySelector('.fd-build-box-popup__footer'),
      drawerHead: root.querySelector('[data-drawer-head]'),
      drawerText: root.querySelector('[data-drawer-text]'),
      drawerToggle: root.querySelector('[data-drawer-toggle]'),
      drawerBody: root.querySelector('[data-drawer-body]'),
      drawerRows: root.querySelector('[data-drawer-rows]'),
      drawerGifts: root.querySelector('[data-drawer-gifts]'),
      drawerTotals: root.querySelector('[data-drawer-totals]'),
      drawerCallout: root.querySelector('[data-drawer-callout]'),
      drawerScrim: root.querySelector('[data-drawer-scrim]'),
      sheet: root.querySelector('[data-sheet]'),
      sheetContent: root.querySelector('[data-sheet-content]'),
      sheetPrimary: root.querySelector('[data-sheet-primary]'),
      sheetCloseBtns: root.querySelectorAll('[data-sheet-close]'),
      sheetContinue: root.querySelector('[data-sheet-continue]'),
    };
    this.drawerMode = !!(this.config.summaryDrawer && this.config.tiers.length && this.els.drawerText);
    this.bind();
    onGroupChange(this.groupId, this.onGroupChange.bind(this));
    this.render();
  }

  FdBuildBoxPopup.prototype.onGroupChange = function () {
    if (this.root.classList.contains('is-open')) this.render();
  };

  FdBuildBoxPopup.prototype.readConfig = function () {
    var el = this.root.querySelector('[data-popup-config]');
    var parsed = {};
    try {
      parsed = JSON.parse(el ? el.textContent : '{}');
    } catch (e) {
      parsed = {};
    }
    return {
      groupId: parsed.groupId || this.groupId,
      sellingPlanId: parsed.sellingPlanId || '',
      addonSellingPlanId: parsed.addonSellingPlanId || '',
      categories: Array.isArray(parsed.categories) ? parsed.categories : [],
      badges: parsed.badges && typeof parsed.badges === 'object' ? parsed.badges : {},
      addProductsText: parsed.addProductsText || 'Add Your First Product',
      checkoutText: parsed.checkoutText || 'Shop Now',
      afterAdd: parsed.afterAdd || 'checkout',
      bundleTitle: parsed.bundleTitle || 'Your Box',
      mainImage: parsed.mainImage || '',
      tierGiftIcon: parsed.tierGiftIcon || '',
      proofTagIcon: parsed.proofTagIcon || '',
      summaryDrawer: parsed.summaryDrawer === true,
      hideProductInfo: parsed.hideProductInfo === true,
      tiers: normalizeTiers(parsed.tiers),
      giftsInSavings: parsed.giftsInSavings === true,
      listPriceCents: parseInt(parsed.listPriceCents, 10) || 0,
    };
  };

  FdBuildBoxPopup.prototype.isFlatCatalog = function () {
    var cats = this.config.categories || [];
    return cats.length === 1 && cats[0] && cats[0].flat === true;
  };

  FdBuildBoxPopup.prototype.ensureProductsHydrated = function () {
    var self = this;
    if (this._hydratePromise) return this._hydratePromise;

    var tasks = [];
    (this.config.categories || []).forEach(function (cat) {
      (cat.products || []).forEach(function (product) {
        if (!product || !product.variantId) return;
        if (!product.needsHydration && product.price && product.title && product.title !== 'Product') return;

        tasks.push(
          fetch('/variants/' + encodeURIComponent(product.variantId) + '.json')
            .then(function (res) {
              if (!res.ok) throw new Error('variant fetch failed');
              return res.json();
            })
            .then(function (payload) {
              var variant = payload && payload.variant;
              if (!variant) return;

              if (!product.title || product.title === 'Product') {
                product.title = variant.name || variant.title || product.title;
              }
              if (!product.variantTitle && variant.title && variant.title !== 'Default Title') {
                product.variantTitle = variant.title;
              }
              if (!product.price) product.price = variant.price;
              if (!product.compareAtPrice) {
                product.compareAtPrice = variant.compare_at_price || variant.price || product.price;
              }
              if (!product.image && variant.featured_image && variant.featured_image.src) {
                product.image = variant.featured_image.src;
              }
              product.needsHydration = false;
            })
            .catch(function () {
              /* hydration optional */
            })
        );
      });
    });

    if (!tasks.length) return Promise.resolve();
    this._hydratePromise = Promise.all(tasks).then(function () {
      self._hydratePromise = null;
    });
    return this._hydratePromise;
  };

  FdBuildBoxPopup.prototype.bind = function () {
    var self = this;

    Array.prototype.forEach.call(this.els.closeBtns, function (btn) {
      btn.addEventListener('click', function () {
        if (self.state.submitting) return;
        self.close();
      });
    });

    document.addEventListener('fd-build-box:open', function (e) {
      if (!e.detail || e.detail.groupId !== self.groupId) return;
      self.open();
    });

    if (this.fastCart) {
      window.addEventListener('pagehide', function () {
        if (self.prime && !self.state.submitted) self.unprimeCart(true);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !self.root.classList.contains('is-open') || self.state.submitting) return;
      if (self.state.sheetOpen) {
        self.closeSheet();
        return;
      }
      if (self.drawerMode && self.state.drawerOpen && !self.isDrawerPinned()) {
        self.setDrawerOpen(false);
        if (self.els.drawerToggle) self.els.drawerToggle.focus();
        return;
      }
      self.close();
    });

    if (this.drawerMode) this.bindDrawer();

    if (this.els.cats) {
      this.els.cats.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cat-key]');
        if (!btn) return;
        var key = btn.getAttribute('data-cat-key');
        self.state.activeCat = key;
        self.highlightCats();
        self.scrollActiveCatIntoView();
        self.scrollToCat(key);
        btn.blur();
      });
    }

    if (this.els.products) {
      this.els.products.addEventListener('click', function (e) {
        var info = e.target.closest('[data-box-info]');
        if (info) {
          self.openProductInfo(info.getAttribute('data-box-info'), info.closest('[data-product-card]'));
          return;
        }
        var add = e.target.closest('[data-add]');
        var dec = e.target.closest('[data-dec]');
        var inc = e.target.closest('[data-inc]');
        var id = null;
        if (add || dec || inc) id = (add || dec || inc).getAttribute('data-variant-id');
        if (!id) return;
        var g = getGroup(self.groupId);
        var current = Number(g.qty[id]) || 0;
        if (add) {
          if (self.drawerMode) self.lastAdd = { id: id, at: Date.now() };
          self.setQty(id, current > 0 ? current : 1, e.target.closest('[data-product-card]'));
          return;
        }
        if (inc) {
          var last = self.lastAdd;
          if (last && last.id === id && Date.now() - last.at < 200) return;
          self.setQty(id, current + 1);
          return;
        }
        if (dec) {
          self.setQty(id, current - 1);
        }
      });
    }

    if (this.els.scroll) {
      this.els.scroll.addEventListener(
        'scroll',
        function () {
          self.syncActiveCatFromScroll();
        },
        { passive: true }
      );
      this.els.scroll.addEventListener('scrollend', function () {
        self.unlockCatScrollSpy();
      });
    }

    if (this.els.checkout) {
      this.els.checkout.addEventListener('click', function () {
        self.submit();
      });
    }
  };

  FdBuildBoxPopup.prototype.open = function () {
    var self = this;
    clearTimeout(this._unprimeTimer);
    this.state.submitted = false;
    this.warmCartData();
    this.state.packTarget = Number(getGroup(this.groupId).count) || 0;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fd-build-box-open');
    this.ensureProductsHydrated().then(function () {
      self.render();
      initCountUps(self.root);
      var context = window.FDCartContext;
      if (context && typeof context.warmPreorderTextIn === 'function') {
        context.warmPreorderTextIn(self.root);
        context.warmPreorderText((getGroup(self.groupId).gifts || []).map(function (gift) { return gift && gift.variantId; }));
      }
    });
  };

  FdBuildBoxPopup.prototype.close = function () {
    var self = this;
    if (this.state.sheetOpen) this.closeSheet(true);
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fd-build-box-open');
    // Left without adding: give the cart back its codes, unless they reopen soon.
    if (this.prime && !this.state.submitted) {
      clearTimeout(this._unprimeTimer);
      this._unprimeTimer = setTimeout(function () {
        if (!self.root.classList.contains('is-open')) self.unprimeCart(false);
      }, 2000);
    }
  };

  FdBuildBoxPopup.prototype.totalQty = function () {
    var g = getGroup(this.groupId);
    var t = 0;
    Object.keys(g.qty || {}).forEach(function (id) {
      t += Number(g.qty[id]) || 0;
    });
    return t;
  };

  FdBuildBoxPopup.prototype.setQty = function (variantId, next, cardEl) {
    var g = getGroup(this.groupId);
    var total = this.totalQty();
    var current = Number(g.qty[variantId]) || 0;
    next = Math.max(0, next | 0);

    if (next <= 0) {
      delete g.qty[variantId];
    } else {
      g.qty[variantId] = next;
      if (cardEl) {
        var title = cardEl.getAttribute('data-title') || '';
        var image = cardEl.getAttribute('data-image') || '';
        var variantTitle = cardEl.getAttribute('data-variant-title') || '';
        g.productMeta[variantId] = { title: title, image: image, variantTitle: variantTitle };
      }
    }

    this.upgradeDealIfNeeded();
    notify(this.groupId);

    if (this.fastCart && next > current) {
      var product = this.findProduct(variantId);
      warmProductForCart(product && product.handle, variantId, false);
      this.primeCart();
    }
  };

  FdBuildBoxPopup.prototype.upgradeDealIfNeeded = function () {
    var g = getGroup(this.groupId);
    var filled = this.totalQty();
    if (filled <= (g.count || 0)) return;

    var qtyEl = document.querySelector(
      '[data-fd-build-box][data-group="' + this.groupId + '"]'
    );
    var qtyInst = qtyEl && qtyEl.__fdBuildBox;
    if (!qtyInst) return;

    var target = Math.min(filled, g.maxCount || filled);
    var best = null;
    var bestCount = Infinity;
    var maxBtn = null;
    var maxC = 0;

    Array.prototype.forEach.call(qtyInst.els.deals, function (el) {
      if (el.disabled) return;
      var c = parseInt(el.getAttribute('data-deal-count'), 10) || 0;
      if (c > maxC) {
        maxC = c;
        maxBtn = el;
      }
      if (c >= target && c < bestCount) {
        best = el;
        bestCount = c;
      }
    });

    var btn = best || maxBtn;
    if (btn && btn.getAttribute('data-deal-id') !== g.dealId) {
      qtyInst.selectDeal(btn, true);
    }
  };

  FdBuildBoxPopup.prototype.render = function () {
    var g = getGroup(this.groupId);
    this.renderHero(g);
    this.renderCats();
    this.renderProducts();
    this.renderPopupGifts(g);
    if (this.drawerMode) {
      this.renderDrawerTitle(g);
      this.renderDrawer(g);
    } else if ((this.config.tiers || []).length) {
      this.renderTierBar(g);
      this.renderTierSummary(g);
    } else this.renderSlots(g);
    this.renderCheckout(g);
  };

  FdBuildBoxPopup.prototype.renderHero = function (g) {
    if (!this.els.hero) return;
    var dealImg = (g && g.heroImage ? String(g.heroImage) : '').trim();
    var productImg = (this.config.mainImage || '').trim();
    var src = dealImg || productImg;
    var collageEl = this.els.heroCollage;
    var giftImgs = ((g && g.gifts) || [])
      .map(function (gift) {
        return gift && gift.image ? gift.image : '';
      })
      .filter(Boolean)
      .slice(0, 4);

    if (src && this.els.heroImg) {
      this.els.heroImg.src = src;
      this.els.heroImg.hidden = false;
      this.els.hero.classList.add('has-image');
      this.els.hero.classList.remove('is-collage');
      if (collageEl) {
        collageEl.hidden = true;
        collageEl.innerHTML = '';
      }
            return;
    }

    if (giftImgs.length && collageEl) {
      if (this.els.heroImg) this.els.heroImg.hidden = true;
      this.els.hero.classList.add('has-image', 'is-collage');
      collageEl.hidden = false;
      collageEl.innerHTML = giftImgs
        .map(function (url) {
          return (
            '<span class="fd-build-box-popup__hero-collage-cell">' +
            '<img src="' +
            escapeHtml(url) +
            '" alt="" loading="lazy">' +
            '</span>'
          );
        })
        .join('');
            return;
    }

    if (this.els.heroImg) this.els.heroImg.hidden = true;
    this.els.hero.classList.remove('has-image', 'is-collage');
    if (collageEl) {
      collageEl.hidden = true;
      collageEl.innerHTML = '';
    }
      };

  FdBuildBoxPopup.prototype.renderCats = function () {
    if (!this.els.cats) return;
    var cats = this.config.categories;
    if (!cats.length || this.isFlatCatalog()) {
      this.els.cats.innerHTML = '';
      return;
    }
    if (!this.state.activeCat) this.state.activeCat = cats[0].key;
    this.els.cats.innerHTML = cats
      .map(function (cat) {
        var active = cat.key === this.state.activeCat ? ' is-active' : '';
        return (
          '<button type="button" class="fd-build-box-popup__cat' +
          active +
          '" data-cat-key="' +
          escapeHtml(cat.key) +
          '">' +
          escapeHtml(cat.label) +
          '</button>'
        );
      }, this)
      .join('');
  };

  FdBuildBoxPopup.prototype.highlightCats = function () {
    if (!this.els.cats) return;
    var active = this.state.activeCat;
    Array.prototype.forEach.call(this.els.cats.querySelectorAll('[data-cat-key]'), function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-cat-key') === active);
    });
  };

  FdBuildBoxPopup.prototype.scrollActiveCatIntoView = function () {
    if (!this.els.cats || !this.state.activeCat) return;
    var btn = this.els.cats.querySelector('[data-cat-key="' + this.state.activeCat + '"]');
    if (!btn) return;
    var nav = this.els.cats;
    var left = btn.offsetLeft - (nav.clientWidth - btn.offsetWidth) / 2;
    nav.scrollTo({
      left: Math.max(0, left),
      behavior: 'smooth',
    });
  };

  FdBuildBoxPopup.prototype.lockCatScrollSpy = function () {
    var self = this;
    this.state.scrollingToCat = true;
    if (this._catScrollUnlockTimer) clearTimeout(this._catScrollUnlockTimer);
    this._catScrollUnlockTimer = setTimeout(function () {
      self.unlockCatScrollSpy();
    }, 700);
  };

  FdBuildBoxPopup.prototype.unlockCatScrollSpy = function () {
    if (!this.state.scrollingToCat) return;
    this.state.scrollingToCat = false;
    if (this._catScrollUnlockTimer) {
      clearTimeout(this._catScrollUnlockTimer);
      this._catScrollUnlockTimer = null;
    }
    this.syncActiveCatFromScroll();
  };

  FdBuildBoxPopup.prototype.scrollToCat = function (key) {
    if (!this.els.products || !this.els.scroll) return;
    var section = this.els.products.querySelector('[data-cat-section="' + key + '"]');
    if (!section) return;
    var scroll = this.els.scroll;
    var top =
      section.getBoundingClientRect().top -
      scroll.getBoundingClientRect().top +
      scroll.scrollTop;
    this.lockCatScrollSpy();
    if (typeof scroll.scrollTo === 'function') {
      scroll.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
      scroll.scrollTop = Math.max(0, top);
      this.unlockCatScrollSpy();
    }
  };

  FdBuildBoxPopup.prototype.syncActiveCatFromScroll = function () {
    if (this.state.scrollingToCat) return;
    if (!this.els.products || !this.els.scroll) return;
    var scroll = this.els.scroll;
    var sections = this.els.products.querySelectorAll('[data-cat-section]');
    if (!sections.length) return;

    var marker = scroll.getBoundingClientRect().top + 24;
    var current = sections[0].getAttribute('data-cat-section');
    Array.prototype.forEach.call(sections, function (sec) {
      if (sec.getBoundingClientRect().top <= marker) {
        current = sec.getAttribute('data-cat-section');
      }
    });

    if (scroll.scrollTop + scroll.clientHeight >= scroll.scrollHeight - 8) {
      current = sections[sections.length - 1].getAttribute('data-cat-section');
    }

    if (current && current !== this.state.activeCat) {
      this.state.activeCat = current;
      this.highlightCats();
      this.scrollActiveCatIntoView();
    }
  };

  FdBuildBoxPopup.prototype.renderProducts = function () {
    if (!this.els.products) return;
    var g = getGroup(this.groupId);
    var flat = this.isFlatCatalog();
    var badges = this.config.badges || {};
    var tiers = this.config.tiers || [];
    var nextPct = tiers.length ? tierPercentFor(tiers, this.totalQty() + 1, g.subscribe !== false) : null;
    var cardOpts = { hideInfo: this.config.hideProductInfo, mediaInfo: this.drawerMode };
    var html = '';
    this.config.categories.forEach(function (cat) {
      html +=
        '<section class="fd-build-box-popup__cat-section' +
        (flat ? ' is-flat' : '') +
        '" data-cat-section="' +
        escapeHtml(cat.key) +
        '">';
      if (!flat) {
        html +=
          '<h3 class="fd-build-box-popup__cat-title">' +
          '<span class="fd-build-box-popup__cat-label">' +
          escapeHtml(cat.label) +
          '</span>' +
          (cat.ages
            ? '<span class="fd-build-box-popup__cat-ages">' + escapeHtml(cat.ages) + '</span>'
            : '') +
          '</h3>';
      }
      (cat.products || []).forEach(function (p) {
        var list = parseInt(p.price, 10) || 0;
        var price = nextPct != null && list > 0 ? { list: list, final: discountedCents(list, nextPct) } : null;
        html += renderProductCard(p, Number(g.qty[String(p.variantId)]) || 0, badges, price, cardOpts);
      });
      html += '</section>';
    });
    this.els.products.innerHTML = html;
  };

  FdBuildBoxPopup.prototype.renderPopupGifts = function (g) {
    if (!this.els.popupGifts) return;
    var gifts = g.gifts || [];
    var filled = this.totalQty();
    var earned = earnedGiftTier(g.dealCounts, filled);
    var infoModal = !this.config.hideProductInfo;
    this.els.popupGifts.innerHTML = gifts
      .map(function (gift, i) {
        var unlocked = i < earned;
        return renderGiftCard(gift, { locked: !unlocked, unlocked: unlocked, infoModal: infoModal });
      })
      .join('');
  };

  FdBuildBoxPopup.prototype.renderTierBar = function (g) {
    if (!this.els.slots) return;
    var self = this;
    var tiers = this.config.tiers || [];
    var icon = this.config.tierGiftIcon || '';
    var gifts = g.gifts || [];
    var productQty = this.totalQty();
    var active = currentTier(tiers, productQty);
    var subscribe = g.subscribe !== false;
    var html = '';
    tiers.forEach(function (tier, i) {
      var pct = subscribe ? tier.percent : tier.otpPercent;
      if (!isFinite(pct)) pct = 0;
      pct = self.shownTierPercent(g, tier.qty, pct);
      var lit = productQty >= tier.qty;
      /* tier icon: gift image when filled, generic glyph otherwise */
      var giftImg = gifts[i] && gifts[i].image ? gifts[i].image : '';
      var thumb = giftImg || icon;
      html +=
        '<div class="fd-build-box-popup__slot fd-build-box-popup__slot--tier' +
        (lit ? ' is-filled' : '') +
        (active && active.qty === tier.qty ? ' is-current' : '') +
        '" data-tier-qty="' +
        tier.qty +
        '">' +
        '<span class="fd-build-box-popup__slot-thumb">' +
        (thumb
          ? '<img src="' + escapeHtml(thumb) + '" alt="" width="30" height="30" loading="lazy">'
          : '') +
        '</span>' +
        '<span class="fd-build-box-popup__slot-pct">' +
        '<span class="fd-build-box-popup__slot-pct-num">' +
        escapeHtml(pct) +
        '%</span>' +
        '<span class="fd-build-box-popup__slot-pct-off">OFF</span>' +
        '</span>' +
        '</div>';
    });
    this.els.slots.innerHTML = html;
  };

  FdBuildBoxPopup.prototype.renderTierSummary = function (g) {
    if (!this.els.summary) return;
    var self = this;
    var tiers = this.config.tiers || [];
    var subscribe = g.subscribe !== false;
    var filled = this.totalQty();
    var pct = tierPercentFor(tiers, filled, subscribe);
    var list = 0;
    var total = 0;
    Object.keys(g.qty || {}).forEach(function (id) {
      var qty = Number(g.qty[id]) || 0;
      var product = self.findProduct(id);
      var cents = (product && parseInt(product.price, 10)) || 0;
      list += cents * qty;
      total += discountedCents(cents, pct) * qty;
    });
    var next = nextTierFor(tiers, filled, subscribe);
    var compare = list + this.shownGiftCents(g, filled);
    var line = '';
    if (next) {
      var need = next.qty - filled;
      var nextPct = this.shownTierPercent(g, next.qty, next.percent, filled > 0 ? list / filled : 0);
      line = 'Add ' + need + (filled > 0 ? ' more' : need === 1 ? ' bottle' : ' bottles') + ' for ' + nextPct + '% off';
    } else if (filled > 0 && pct > 0) {
      line = 'You unlocked ' + (this.config.giftsInSavings ? savedPercent(total, compare) : pct) + '% off, the top tier';
    }
    if (this.els.tierNext) this.els.tierNext.textContent = line;
    if (this.els.boxTotal) {
      this.els.boxTotal.innerHTML =
        filled > 0
          ? (total < compare
              ? '<s class="fd-build-box-popup__total-compare">' + money(compare) + '</s> '
              : '') +
            '<strong class="fd-build-box-popup__total-final">' +
            money(total) +
            '</strong>'
          : '';
    }
    this.els.summary.hidden = !line && filled <= 0;
  };

  FdBuildBoxPopup.prototype.boxNumbers = function (g) {
    var self = this;
    var tiers = this.config.tiers || [];
    var sub = g.subscribe !== false;
    var filled = this.totalQty();
    var pct = tierPercentFor(tiers, filled, sub);
    var plusPct = tierPercentFor(tiers, filled + 1, sub);
    var gifts = g.gifts || [];
    var earned = earnedGiftTier(g.dealCounts, filled);
    var plusEarned = earnedGiftTier(g.dealCounts, filled + 1);
    var plusGift = plusEarned > earned && gifts[earned] ? gifts[earned] : null;
    var list = 0;
    var total = 0;
    var rows = [];
    Object.keys(g.qty || {}).forEach(function (id) {
      var qty = Number(g.qty[id]) || 0;
      if (qty <= 0) return;
      var product = self.findProduct(id);
      var cents = (product && parseInt(product.price, 10)) || 0;
      list += cents * qty;
      total += discountedCents(cents, pct) * qty;
      if (product) rows.push({ product: product, qty: qty, list: cents * qty, final: discountedCents(cents, pct) * qty });
    });
    var plusSaving = filled > 0 ? Math.round(((list + list / filled) * plusPct) / 100) : 0;
    var n = {
      filled: filled,
      pct: pct,
      plusPct: plusPct > pct ? plusPct : 0,
      plusGift: plusGift,
      next: nextTierFor(tiers, filled, sub),
      earned: earned,
      gifts: gifts,
      list: list,
      compare: list,
      total: total,
      saving: list - total,
      plusSaving: plusSaving,
      rows: rows,
    };
    if (!this.config.giftsInSavings) return n;
    var unit = filled > 0 ? list / filled : 0;
    n.compare = list + this.shownGiftCents(g, filled);
    n.pct = savedPercent(total, n.compare);
    n.saving = n.compare - total;
    var plusUnit = unit || this.config.listPriceCents;
    if (n.plusPct && plusUnit > 0) {
      var plusFull = plusUnit * (filled + 1) + this.shownGiftCents(g, filled + 1);
      var plusPaid = discountedCents(plusUnit, n.plusPct) * (filled + 1);
      n.plusPct = savedPercent(plusPaid, plusFull);
      n.plusSaving = filled > 0 ? Math.round(plusFull - plusPaid) : 0;
    }
    if (n.next) n.next = { qty: n.next.qty, percent: this.shownTierPercent(g, n.next.qty, n.next.percent, unit) };
    return n;
  };

  FdBuildBoxPopup.prototype.shownGiftCents = function (g, qty) {
    return this.config.giftsInSavings ? giftValueCents(g.gifts, earnedGiftTier(g.dealCounts, qty)) : 0;
  };

  /* % shown for a `qty` bottle box charged `pct` off, at `unitCents` list per bottle (default: Step 1 list price). */
  FdBuildBoxPopup.prototype.shownTierPercent = function (g, qty, pct, unitCents) {
    if (!this.config.giftsInSavings) return pct;
    var unit = unitCents || this.config.listPriceCents;
    if (!(unit > 0)) return pct;
    return savedPercent(discountedCents(unit, pct) * qty, unit * qty + this.shownGiftCents(g, qty));
  };

  FdBuildBoxPopup.prototype.bindDrawer = function () {
    var self = this;
    this.desktopMq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
    if (this.desktopMq) {
      var onMq = function () {
        self.renderDrawer(getGroup(self.groupId));
      };
      if (this.desktopMq.addEventListener) this.desktopMq.addEventListener('change', onMq);
      else if (this.desktopMq.addListener) this.desktopMq.addListener(onMq);
    }
    if (this.els.drawerHead) {
      this.els.drawerHead.addEventListener('click', function () {
        if (self.isDrawerPinned()) return;
        self.setDrawerOpen(!self.state.drawerOpen);
      });
    }
    if (this.els.drawerScrim) {
      this.els.drawerScrim.addEventListener('click', function () {
        self.setDrawerOpen(false);
        if (self.els.drawerToggle) self.els.drawerToggle.focus();
      });
    }
    if (this.els.drawerRows) {
      this.els.drawerRows.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-inc], [data-dec]');
        if (!btn) return;
        var id = btn.getAttribute('data-variant-id');
        var inc = btn.hasAttribute('data-inc');
        var current = Number(getGroup(self.groupId).qty[id]) || 0;
        self.setQty(id, current + (inc ? 1 : -1));
        var again = self.els.drawerRows.querySelector(
          '[data-variant-id="' + id + '"]' + (inc ? '[data-inc]' : '[data-dec]')
        );
        if (again) again.focus();
        else if (self.isDrawerPinned()) {
          if (self.els.checkout && !self.els.checkout.disabled) self.els.checkout.focus();
        } else if (self.els.drawerToggle) self.els.drawerToggle.focus();
      });
    }
    Array.prototype.forEach.call(this.els.sheetCloseBtns || [], function (btn) {
      btn.addEventListener('click', function () {
        self.closeSheet();
      });
    });
    if (this.els.sheetContinue) {
      this.els.sheetContinue.addEventListener('click', function () {
        self.closeSheet(true);
        self.submit({ skipSheet: true });
      });
    }
  };

  FdBuildBoxPopup.prototype.isDrawerPinned = function () {
    return !!(this.desktopMq && this.desktopMq.matches);
  };

  FdBuildBoxPopup.prototype.setDrawerOpen = function (open) {
    this.state.drawerOpen = !!open;
    this.renderDrawer(getGroup(this.groupId));
  };

  FdBuildBoxPopup.prototype.renderDrawerTitle = function (g) {
    if (!this.els.title) return;
    var n = this.state.packTarget || Number(g.count) || 0;
    if (n < 1) return;
    this.els.title.textContent = 'Select At Least ' + n + (n === 1 ? ' Bottle' : ' Bottles');
  };

  FdBuildBoxPopup.prototype.drawerHeadHtml = function (n) {
    if (n.filled < 1) return 'Add first product to earn gifts';
    if (n.plusPct || n.plusGift) {
      var parts = [];
      if (n.plusPct) {
        parts.push('<strong class="fd-build-box-popup__drawer-pct">' + escapeHtml(n.plusPct) + '% Off</strong>');
      }
      if (n.plusGift) {
        parts.push(
          '<strong class="fd-build-box-popup__drawer-gift">Free ' +
            escapeHtml(n.plusGift.displayName || n.plusGift.label || 'Gift') +
            '</strong>'
        );
      }
      return 'Add one more product to unlock<br>' + parts.join(' + ');
    }
    if (n.next) {
      return (
        'Add ' +
        (n.next.qty - n.filled) +
        ' more products to unlock<br><strong class="fd-build-box-popup__drawer-pct">' +
        escapeHtml(n.next.percent) +
        '% Off</strong>'
      );
    }
    return n.pct > 0 ? 'You unlocked ' + escapeHtml(n.pct) + '% off, the top tier' : '';
  };

  function offBadgeHtml(pct, strong, light) {
    return (
      '<span class="fd-badge fd-badge--sm ' +
      (light ? 'fd-badge--success-light' : 'fd-badge--success fd-build-box-popup__drawer-badge') +
      '">' +
      (strong ? '<strong>' + escapeHtml(pct) + '%</strong>\u00a0OFF' : escapeHtml(pct) + '% OFF') +
      '</span>'
    );
  }

  FdBuildBoxPopup.prototype.renderDrawer = function (g) {
    if (!this.els.drawerText) return;
    var n = this.boxNumbers(g);
    var pinned = this.isDrawerPinned();
    var open = pinned || this.state.drawerOpen;

    this.els.drawerText.innerHTML = this.drawerHeadHtml(n);
    if (this.els.footer) this.els.footer.classList.toggle('is-expanded', open);
    if (this.els.drawerToggle) {
      this.els.drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.els.drawerToggle.setAttribute('aria-label', open ? 'Hide box summary' : 'Show box summary');
    }
    if (this.els.drawerBody) this.els.drawerBody.hidden = !open;
    if (this.els.drawerScrim) this.els.drawerScrim.hidden = !open || pinned;
    if (!open) return;

    if (this.els.drawerRows) {
      this.els.drawerRows.innerHTML = n.rows
        .map(function (r) {
          return renderProductCard(r.product, r.qty, null, { list: r.list, final: r.final }, { compact: true });
        })
        .join('');
    }
    if (this.els.drawerGifts) {
      var infoModal = !this.config.hideProductInfo;
      this.els.drawerGifts.innerHTML = n.gifts
        .map(function (gift, i) {
          var unlocked = i < n.earned;
          return renderGiftCard(gift, {
            locked: !unlocked,
            unlocked: unlocked,
            infoModal: infoModal,
            hideCheck: true,
            showBadge: true,
            captionNameOnly: true,
          });
        })
        .join('');
      this.els.drawerGifts.hidden = !n.gifts.length;
    }
    if (this.els.drawerCallout) {
      var head = this.drawerHeadHtml(n);
      this.els.drawerCallout.innerHTML = head ? this.calloutBoxHtml(head) : '';
      this.els.drawerCallout.hidden = !head;
    }
    if (this.els.drawerTotals) {
      var html =
        '<div class="fd-build-box-popup__drawer-line">' +
        '<span class="fd-build-box-popup__drawer-label">Current Subtotal:</span>' +
        '<span class="fd-build-box-popup__drawer-value">' +
        '<span class="fd-build-box-popup__drawer-amount">' +
        (this.config.giftsInSavings && n.compare > n.total
          ? '<s class="fd-build-box-popup__card-compare">' + money(n.compare) + '</s> '
          : '') +
        money(n.total) +
        '</span>' +
        (n.pct > 0 ? offBadgeHtml(n.pct, false, true) : '') +
        '</span>' +
        '</div>';
      if (n.plusPct || n.plusGift) {
        html +=
          '<div class="fd-build-box-popup__drawer-line">' +
          '<span class="fd-build-box-popup__drawer-label is-strong">Add 1 More Product:</span>' +
          '<span class="fd-build-box-popup__drawer-value is-plus">' +
          (n.plusGift ? '<span>Extra Gift</span>' + (n.plusPct ? '<span>+</span>' : '') : '') +
          (n.plusPct ? offBadgeHtml(n.plusPct, true, false) : '') +
          '</span>' +
          '</div>';
      }
      this.els.drawerTotals.innerHTML = html;
    }
  };

  FdBuildBoxPopup.prototype.calloutBoxHtml = function (textHtml) {
    return (
      '<div class="fd-build-box-popup__sheet-callout">' +
      (this.config.proofTagIcon
        ? '<img class="fd-build-box-popup__sheet-callout-icon" src="' +
          escapeHtml(this.config.proofTagIcon) +
          '" width="24" height="24" alt="" aria-hidden="true">'
        : '') +
      '<p class="fd-build-box-popup__sheet-callout-text">' +
      textHtml +
      '</p>' +
      '</div>'
    );
  };

  FdBuildBoxPopup.prototype.calloutHtml = function (n, lead) {
    return this.calloutBoxHtml(
      lead +
        ' <strong class="fd-build-box-popup__sheet-pct">' +
        escapeHtml(n.plusPct) +
        '% Off</strong> → That\'s <strong>' +
        money(n.plusSaving) +
        '</strong> in savings!'
    );
  };

  FdBuildBoxPopup.prototype.renderSheet = function (g) {
    if (!this.els.sheetContent) return false;
    var n = this.boxNumbers(g);
    if (!n.plusPct && !n.plusGift) return false;
    var html = '';
    if (n.plusGift) {
      var priceText = giftPriceText(n.plusGift);
      html +=
        '<div class="fd-build-box-popup__sheet-gift">' +
        '<div class="fd-build-box__gift is-unlocked fd-build-box-popup__sheet-tile">' +
        '<div class="fd-build-box__gift-media">' +
        (n.plusGift.image
          ? '<img src="' + escapeHtml(n.plusGift.image) + '" alt="" width="120" height="120" loading="lazy">'
          : '') +
        '</div>' +
        '</div>' +
        '<div class="fd-build-box-popup__sheet-gift-copy">' +
        '<p class="fd-build-box-popup__sheet-gift-title">Add 1 More Product To Unlock The <strong>Free ' +
        escapeHtml(n.plusGift.displayName || n.plusGift.label || 'Gift') +
        '</strong></p>' +
        '<p class="fd-build-box-popup__sheet-gift-price">' +
        (priceText ? '<s>' + escapeHtml(priceText) + '</s>' : '') +
        '<strong>FREE</strong>' +
        '</p>' +
        '</div>' +
        '</div>';
    }
    if (n.plusPct) html += this.calloutHtml(n, 'Also with 1 more product you unlock');
    html +=
      '<div class="fd-build-box-popup__sheet-lines">' +
      '<div class="fd-build-box-popup__drawer-line">' +
      '<span class="fd-build-box-popup__drawer-label">Current Subtotal:</span>' +
      '<span class="fd-build-box-popup__drawer-value">' +
      (n.pct > 0 ? offBadgeHtml(n.pct, false, true) : '') +
      '<span class="fd-build-box-popup__drawer-amount">' +
      (n.saving > 0 ? 'Saving ' + money(n.saving) : money(n.total)) +
      '</span>' +
      '</span>' +
      '</div>';
    if (n.plusPct) {
      html +=
        '<div class="fd-build-box-popup__drawer-line">' +
        '<span class="fd-build-box-popup__drawer-label is-strong">Add 1 More Product:</span>' +
        '<span class="fd-build-box-popup__drawer-value">' +
        offBadgeHtml(n.plusPct, true, false) +
        '<strong class="fd-build-box-popup__sheet-save">Save ' +
        money(n.plusSaving) +
        '</strong>' +
        '</span>' +
        '</div>';
    }
    html += '</div>';
    this.els.sheetContent.innerHTML = html;
    return true;
  };

  FdBuildBoxPopup.prototype.openSheet = function () {
    if (!this.els.sheet || !this.renderSheet(getGroup(this.groupId))) return false;
    this.els.sheet.hidden = false;
    this.state.sheetOpen = true;
    this.root.classList.add('is-sheet-open');
    if (this.els.sheetPrimary) this.els.sheetPrimary.focus();
    return true;
  };

  FdBuildBoxPopup.prototype.closeSheet = function (silent) {
    if (!this.els.sheet) return;
    this.els.sheet.hidden = true;
    this.state.sheetOpen = false;
    this.root.classList.remove('is-sheet-open');
    if (!silent && this.els.checkout) this.els.checkout.focus();
  };

  FdBuildBoxPopup.prototype.renderSlots = function (g) {
    if (!this.els.slots) return;
    var gifts = g.gifts || [];
    var slotCount = g.maxCount || gifts.length || g.count || 1;
    var productQty = this.totalQty();
    var earned = earnedGiftTier(g.dealCounts, productQty);
    var html = '';
    for (var s = 0; s < slotCount; s++) {
      var filled = s < earned;
      var thumb = gifts[s] && gifts[s].image ? gifts[s].image : '';
      html +=
        '<div class="fd-build-box-popup__slot' +
        (filled ? ' is-filled' : '') +
        '">' +
        '<span class="fd-build-box-popup__slot-thumb">' +
        (thumb
          ? '<img src="' + escapeHtml(thumb) + '" alt="" width="30" height="30" loading="lazy">'
          : '') +
        (!filled
          ? '<span class="fd-build-box-popup__slot-lock" aria-hidden="true">' + LOCK_SVG + '</span>'
          : '') +
        '</span>' +
        '<span class="fd-build-box-popup__slot-num">' +
        (s + 1) +
        '</span>' +
        '<span class="fd-build-box-popup__slot-check" aria-hidden="true">' +
        CHECK_SVG +
        '</span>' +
        '</div>';
    }
    this.els.slots.innerHTML = html;
  };

  FdBuildBoxPopup.prototype.renderCheckout = function (g) {
    if (!this.els.checkout) return;
    var filled = this.totalQty();
    var submitting = this.state.submitting;
    var ready = filled >= 1 || submitting;
    this.els.checkout.disabled = !ready || submitting;
    this.els.checkout.setAttribute('aria-busy', submitting ? 'true' : 'false');
    this.els.checkout.classList.toggle('is-ready', ready);
    this.els.checkout.classList.toggle('is-loading', submitting);
    this.els.checkout.classList.remove('is-partial');
    if (this.els.checkoutLabel) {
      var readyLabel = this.config.checkoutText;
      if (String(this.config.afterAdd || 'checkout') === 'drawer') {
        readyLabel = String(readyLabel).replace(/\bCheckout\b/g, 'Add');
      }
      this.els.checkoutLabel.textContent = ready ? readyLabel : this.config.addProductsText;
    }
    if (this.els.checkoutArrow) {
      if (ready && !submitting) this.els.checkoutArrow.removeAttribute('hidden');
      else this.els.checkoutArrow.setAttribute('hidden', '');
    }
  };

  FdBuildBoxPopup.prototype.openProductInfo = function (variantId, cardEl) {
    var self = this;
    var product = this.findProduct(variantId);
    if (!product || !product.handle || !window.FDInfoModal) return;
    var g = getGroup(this.groupId);
    var tiers = this.config.tiers || [];
    var list = parseInt(product.price, 10) || 0;
    var pct = tiers.length ? tierPercentFor(tiers, this.totalQty() + 1, g.subscribe !== false) : null;
    window.FDInfoModal.open(product.handle, {
      cta: !this.config.hideProductInfo,
      offer: pct != null && list > 0 ? { price: discountedCents(list, pct), compare: list } : null,
      actions: {
        onAdd: function () {
          var qty = Number(getGroup(self.groupId).qty[String(variantId)]) || 0;
          self.setQty(String(variantId), qty + 1, cardEl);
          return true;
        },
        onNavigate: function () {
          return true;
        },
      },
    });
  };

  FdBuildBoxPopup.prototype.findProduct = function (variantId) {
    var id = String(variantId);
    var cats = this.config.categories || [];
    for (var i = 0; i < cats.length; i++) {
      var products = cats[i].products || [];
      for (var j = 0; j < products.length; j++) {
        if (String(products[j].variantId) === id) return products[j];
      }
    }
    return null;
  };

  FdBuildBoxPopup.prototype.resolveSellingPlanId = function (product) {
    var handle = (product && product.handle) || '';
    var isAddon = handle.indexOf('add-on') !== -1;
    var preferred =
      isAddon && this.config.addonSellingPlanId
        ? String(this.config.addonSellingPlanId)
        : String(this.config.sellingPlanId || '');
    if (product && product.sellingPlanId) return String(product.sellingPlanId);
    return preferred || '';
  };

  FdBuildBoxPopup.prototype.getProductSellingPlanIdForVariant = function (handle, variantId) {
    if (!handle || !variantId) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed');
        return res.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (v) {
          return String(v.id) === String(variantId);
        });
        var allocation =
          variant && Array.isArray(variant.selling_plan_allocations)
            ? variant.selling_plan_allocations[0]
            : null;
        return allocation && allocation.selling_plan_id
          ? String(allocation.selling_plan_id)
          : null;
      })
      .catch(function () {
        return null;
      });
  };

  FdBuildBoxPopup.prototype.buildItems = function () {
    var self = this;
    var g = getGroup(this.groupId);
    var bundleId = uniqueId();
    var title = this.config.bundleTitle || g.dealName || 'Your Box';
    var parentPdpId = this.config.parentProductId || null;
    var parentPdpHandle = this.config.parentProductHandle || null;
    var items = [];
    var pagePath = window.location.pathname;

    var isSubscription = g.subscribe !== false;

    var boxQty = 0;
    Object.keys(g.qty || {}).forEach(function (id) {
      boxQty += Number(g.qty[id]) || 0;
    });
    var activeTier = currentTier(this.config.tiers, boxQty);
    var tierPercent = activeTier
      ? tierPercentFor(this.config.tiers, boxQty, isSubscription)
      : g.tierPercent;
    if (tierPercent == null || !isFinite(tierPercent)) tierPercent = null;

    Object.keys(g.qty || {}).forEach(function (id) {
      var qty = Number(g.qty[id]) || 0;
      if (qty <= 0) return;
      var product = self.findProduct(id);
      var planId = self.resolveSellingPlanId(product);
      var handle = (product && product.handle) || '';
      var isAddon = handle.indexOf('add-on') !== -1;
      var lineProps = stampBundleProps(
        {
          _page_path: pagePath,
          _upsell_module: 'build_box',
        },
        bundleId,
        title,
        parentPdpId,
        parentPdpHandle
      );
      if (tierPercent != null) lineProps._tier_discount_percent = String(tierPercent);

      var item;
      if (window.CartUtilities && typeof window.CartUtilities.createItemData === 'function') {
        item = window.CartUtilities.createItemData({
          variantId: Number(id),
          quantity: qty,
          isSubscription: isSubscription,
          isAddon: isAddon,
          sellingPlanId: isSubscription ? planId || null : null,
          upgradeSellingPlanId: planId || null,
          properties: lineProps,
        });
      } else {
        item = {
          id: Number(id),
          quantity: qty,
          properties: Object.assign(
            {
              _full_price: 'true',
              _product_type: 'rebrand',
            },
            lineProps
          ),
        };
        if (isSubscription) {
          item.properties._is_subscription_purchase = 'true';
          if (planId) {
            item.selling_plan = planId;
            item.properties._if_upgrade__selling_plan_id = String(planId);
          }
        } else {
          item.properties._is_one_time_purchase = 'true';
          if (planId) {
            item.properties._if_upgrade__selling_plan_id = String(planId);
          }
        }
      }
      items.push(item);
    });

    var giftItems = [];
    var productQty = 0;
    Object.keys(g.qty || {}).forEach(function (id) {
      productQty += Number(g.qty[id]) || 0;
    });
    var giftLimit = earnedGiftTier(g.dealCounts, productQty);
    (g.gifts || []).forEach(function (gift, idx) {
      if (idx >= giftLimit) {
        return;
      }
      if (!gift.variantId) {
        return;
      }
      var giftProps = stampBundleProps(
        {
          _bundle_gift: 'true',
          _free_gift: 'true',
          _full_price: 'true',
          _product_type: 'rebrand',
          _is_one_time_purchase: 'true',
          _page_path: pagePath,
        },
        bundleId,
        title,
        parentPdpId,
        parentPdpHandle
      );
      giftItems.push({
        id: Number(gift.variantId),
        quantity: 1,
        properties: giftProps,
      });
    });
    giftItems.forEach(function (item) {
      items.push(item);
    });

    if (typeof window.FDCartContext !== 'undefined' && window.FDCartContext.stampPayload) {
      window.FDCartContext.stampPayload({ items: items });
    } else {
      var d = getThemeDiscount();
      items.forEach(function (item) {
        if (!item || (item.properties && item.properties._bundle_gift === 'true')) return;
        if (!item || (item.properties && item.properties._free_gift === 'true')) return;
        item.properties = item.properties || {};
        if (d.otpCode && !item.properties._otp_discount_code) {
          item.properties._otp_discount_code = d.otpCode;
        }
        if (d.subCode && !item.properties._sub_discount_code) {
          item.properties._sub_discount_code = d.subCode;
        }
        if (d.otpPct != null && !item.properties._otp_discount_percentage) {
          item.properties._otp_discount_percentage = String(d.otpPct);
        }
        if (d.subPct != null && !item.properties._sub_discount_percentage) {
          item.properties._sub_discount_percentage = String(d.subPct);
        }
      });
    }

    // /cart/add.js stores lines newest-first. Gifts go out first so paid lines sit above them.
    items.reverse();
    return items;
  };

  // Codes the cart needs for this box: the page code for the purchase mode plus any
  // code stamped on a paid line (_sub_discount_code / _otp_discount_code), deduped.
  function collectBoxCodes(items, isSub) {
    var codes = [];
    var d = getThemeDiscount();

    if (isSub && d.subCode) codes.push(d.subCode);
    if (!isSub && d.otpCode) codes.push(d.otpCode);

    (items || []).forEach(function (it) {
      var props = (it && it.properties) || {};
      if (isGiftProps(props)) return;
      if (props._sub_discount_code) codes.push(String(props._sub_discount_code));
      if (props._otp_discount_code) codes.push(String(props._otp_discount_code));
    });

    return mergeCodes([], codes);
  }

  // The cart's codes to keep when adding the box codes. Same rule as
  // applyDiscountCodes: while a session offer replaces the sitewide offer
  // (FDOffer, fd-offer-session.js), the sitewide code is dropped.
  // Codes a paid line stamps for itself (_sub_discount_code / _otp_discount_code).
  // A cleanup must never remove one of these: that line's price depends on it.
  function lineClaimedCodes(cart) {
    var claimed = Object.create(null);
    ((cart && cart.items) || []).forEach(function (item) {
      var props = (item && item.properties) || {};
      if (isGiftProps(props)) return;
      [props._sub_discount_code, props._otp_discount_code].forEach(function (code) {
        if (code) claimed[upperCode(code)] = true;
      });
    });
    return claimed;
  }

  // Purchase mode of one box as the cart sees it: subscription when any of its paid
  // lines kept a selling plan (the add handler may strip plans), else the builder's choice.
  function boxIsSubscription(cart, bundleId, fallback) {
    var lines = ((cart && cart.items) || []).filter(function (item) {
      var props = (item && item.properties) || {};
      return bundleId && props._bundle === bundleId && !isGiftProps(props);
    });
    if (!lines.length) return fallback;
    return lines.some(function (item) {
      return !!item.selling_plan_allocation;
    });
  }

  // Take back what primeCart wrote: drop the box codes it added (unless a paid line
  // now claims them, e.g. a box added in another tab), put back the codes it dropped,
  // and reset the purchase-mode attribute, but only on a cart with no paid lines.
  function restorePrimedCart(prime) {
    return Promise.resolve(prime.promise)
      .then(function () {
        if (!(prime.wrote || prime.writing) || !prime.previous) return;
        return readCart().then(function (cart) {
          var claimed = lineClaimedCodes(cart);
          var added = prime.codes
            .filter(function (code) {
              return !hasCode(prime.previous.codes, code) && !claimed[upperCode(code)];
            })
            .map(upperCode);
          var current = cartCodes(cart);
          var keep = current.filter(function (code) {
            return added.indexOf(upperCode(code)) === -1;
          });
          var paid = cartHasPaidLines(cart);
          var next = paid ? keep : mergeCodes(keep, prime.previous.codes);
          var body = {};
          if (next.join(',') !== current.join(',')) body.discount = next.join(',');
          var wanted = subscriptionAttributes(prime.subscribe);
          var attrs = (cart && cart.attributes) || {};
          var untouched = Object.keys(wanted).every(function (key) {
            return String(attrs[key] || '') === wanted[key];
          });
          if (untouched && !paid) body.attributes = prime.previous.attributes;
          if (!Object.keys(body).length) return;
          return writeCart(body);
        });
      })
      .catch(function () {});
  }

  function existingCodesForBox(cart) {
    var offer = window.FDOffer && window.FDOffer.active;
    var dropGlobal =
      offer && offer.replacesGlobal ? upperCode((window.FDOffer && window.FDOffer.globalCode) || '') : '';
    return cartCodes(cart).filter(function (code) {
      return !dropGlobal || upperCode(code) !== dropGlobal;
    });
  }

  FdBuildBoxPopup.prototype.applyDiscountCodes = function (items, knownCart) {
    var codes = [];
    var d = getThemeDiscount();
    var g = getGroup(this.groupId);
    var isSub = g.subscribe !== false;

    if (isSub && d.subCode) codes.push(d.subCode);
    if (!isSub && d.otpCode) codes.push(d.otpCode);

    (items || []).forEach(function (it) {
      var props = (it && it.properties) || {};
      if (props._bundle_gift === 'true' || props._free_gift === 'true') return;
      if (props._sub_discount_code) codes.push(String(props._sub_discount_code));
      if (props._otp_discount_code) codes.push(String(props._otp_discount_code));
    });

    var seen = Object.create(null);
    codes = codes.filter(function (raw) {
      var c = String(raw || '').trim();
      if (!c) return false;
      var key = c.toUpperCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    if (!codes.length) return Promise.resolve();

    var cartReady = knownCart
      ? Promise.resolve(knownCart)
      : fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then(function (res) {
          return res.json();
        });

    return cartReady
      .then(function (cart) {
        var offer = window.FDOffer && window.FDOffer.active;
        var dropGlobal =
          offer && offer.replacesGlobal
            ? String((window.FDOffer && window.FDOffer.globalCode) || '').trim().toUpperCase()
            : '';
        var existing = (cart.discount_codes || [])
          .map(function (entry) {
            return entry && entry.code;
          })
          .filter(function (code) {
            if (!code) return false;
            return !dropGlobal || String(code).toUpperCase() !== dropGlobal;
          });
        var merged = [];
        var seenMerge = Object.create(null);
        existing.concat(codes).forEach(function (c) {
          var key = String(c).toUpperCase();
          if (seenMerge[key]) return;
          seenMerge[key] = true;
          merged.push(c);
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: merged.join(',') }),
        }).then(function (res) {
          return res.ok ? res.json() : null;
        });
      })
      .catch(function () {});
  };

  FdBuildBoxPopup.prototype.refreshOpenDrawer = function () {
    var self = this;
    var display = cartDisplayFn();
    var ready = Promise.resolve();
    if (
      typeof display === 'function' &&
      window.FDCartApi &&
      typeof window.FDCartApi.getCart === 'function'
    ) {
      ready = window.FDCartApi.getCart(true).then(function (fresh) {
        return display(fresh);
      });
    }
    return Promise.resolve(ready).finally(function () {
      self.state.submitting = false;
      self.renderCheckout(getGroup(self.groupId));
    });
  };

  // ---- Prepare the cart while the shopper builds (after_add = drawer) --------

  // Warm what the add and the cart drawer will ask for: the add shim's variant
  // lookups, the product JSON behind the drawer's tag checks (PBFCM_PRODUCT_DATA),
  // and for gift lines the reviews badge + blurb Storefront queries.
  FdBuildBoxPopup.prototype.warmCartData = function () {
    if (!this.fastCart) return;
    var self = this;
    var g = getGroup(this.groupId);
    whenIdle(function () {
      Object.keys(g.qty || {}).forEach(function (id) {
        var product = self.findProduct(id);
        warmProductForCart(product && product.handle, id, false);
      });
      (g.gifts || []).forEach(function (gift) {
        if (gift && gift.variantId) warmProductForCart(gift.handle, gift.variantId, true);
      });
    });
  };

  // Put the box's discount code (and the purchase-mode cart attribute) on the cart
  // before Shop Now, so the add comes back already priced. Only when the cart has
  // no paid lines: an empty cart keeps the code as "not applicable" until the box
  // lands, and the drawer's code cleanup ignores not-applicable codes.
  FdBuildBoxPopup.prototype.primeCart = function () {
    if (!this.fastCart || this.prime) return;
    var subscribe = getGroup(this.groupId).subscribe !== false;
    var codes = collectBoxCodes(this.buildItems(), subscribe);
    if (!codes.length) return;

    var prime = { codes: codes, subscribe: subscribe, ok: false, wrote: false, previous: null };
    this.prime = prime;
    prime.promise = readCart()
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        prime.previous = {
          codes: cartCodes(cart),
          attributes: {
            _is_subscription_purchase: attrs._is_subscription_purchase || '',
            _is_one_time_purchase: attrs._is_one_time_purchase || '',
          },
        };
        if (cartHasPaidLines(cart)) return;
        var wanted = subscriptionAttributes(subscribe);
        var kept = existingCodesForBox(cart);
        var merged = mergeCodes(kept, codes);
        var sameAttrs = Object.keys(wanted).every(function (key) {
          return String(attrs[key] || '') === wanted[key];
        });
        if (merged.length === prime.previous.codes.length && kept.length === prime.previous.codes.length && sameAttrs) {
          prime.ok = true;
          return;
        }
        prime.writing = true;
        return writeCart({ discount: merged.join(','), attributes: wanted }).then(function () {
          prime.ok = true;
          prime.wrote = true;
        });
      })
      .catch(function () {
        prime.ok = false;
      });
  };

  // Take back what primeCart added when the shopper leaves without adding the box.
  // Codes and attributes someone else changed in the meantime are left alone.
  FdBuildBoxPopup.prototype.unprimeCart = function (viaBeacon) {
    var prime = this.prime;
    this.prime = null;
    if (!prime || this.state.submitted) return;

    if (viaBeacon) {
      // Page is going away: no time to read the cart. Best effort, also covers a
      // prime write that is still in flight.
      if (!(prime.wrote || prime.writing) || !prime.previous || typeof navigator.sendBeacon !== 'function') return;
      var form = new URLSearchParams();
      form.append('discount', prime.previous.codes.join(','));
      Object.keys(prime.previous.attributes).forEach(function (key) {
        form.append('attributes[' + key + ']', prime.previous.attributes[key]);
      });
      navigator.sendBeacon('/cart/update.js', form);
      return;
    }

    restorePrimedCart(prime);
  };

  // ---- Shop Now (after_add = drawer) -----------------------------------------

  // What the cart drawer will show, from the builder's own state, so the loading
  // state can draw the real box and gifts at 0ms and only the prices wait.
  FdBuildBoxPopup.prototype.cartPreview = function (items) {
    var self = this;
    var g = getGroup(this.groupId);
    var nav = document.getElementById('main-nav');
    var settingImage = nav && nav.getAttribute('data-build-box-cart-image');
    var contents = [];
    var firstImage = '';
    var gifts = [];

    (items || []).forEach(function (item) {
      var props = (item && item.properties) || {};
      if (isGiftProps(props)) {
        var gift = (g.gifts || []).filter(function (entry) {
          return entry && String(entry.variantId) === String(item.id);
        })[0];
        gifts.push({
          title: (gift && (warmedTitles[gift.handle] || gift.displayName || gift.label)) || '',
          image: (gift && gift.image) || '',
        });
        return;
      }
      var product = self.findProduct(item.id);
      var meta = (g.productMeta && g.productMeta[String(item.id)]) || {};
      var title = (product && (warmedTitles[product.handle] || product.title)) || meta.title || '';
      if (!firstImage) firstImage = (product && product.image) || meta.image || '';
      contents.push((Number(item.quantity) || 1) + 'x ' + title);
    });

    // /cart/add.js order is reversed (gifts first); the drawer lists them in pick order.
    gifts.reverse();
    contents.reverse();

    return {
      title: this.config.bundleTitle || 'Your Box',
      image: settingImage || firstImage,
      contents: contents,
      gifts: gifts,
    };
  };

  // Add the box, make sure the cart carries the box code, then paint the drawer
  // once with the confirmed cart. The drawer never shows a price the checkout
  // will not charge: until that paint, prices and the total stay as placeholders
  // and checkout is locked.
  FdBuildBoxPopup.prototype.submitToDrawer = function (items) {
    var self = this;
    var g = getGroup(this.groupId);
    var subscribe = g.subscribe !== false;
    var codes = collectBoxCodes(items, subscribe);
    var prime = this.prime;
    var display = cartDisplayFn();
    var finished = false;
    var markStart = markCartTiming('fd-bb:shop-now');

    showCartSkeleton(this.cartPreview(items));
    holdCartRenders(true);
    openCartDrawer();

    var safety = setTimeout(function () {
      finish(null, null);
    }, CART_RENDER_HOLD_MS);

    function finish(cart, err) {
      if (finished) return;
      finished = true;
      clearTimeout(safety);
      holdCartRenders(false);
      hideCartSkeleton();
      self.prime = null;
      self.state.submitted = false;
      self.state.submitting = false;
      self.renderCheckout(getGroup(self.groupId));

      if (!cart) {
        // The box did not make it (or the cart could not be read): take back what the
        // prime wrote. restorePrimedCart keeps any code a box line in the cart claims.
        if (prime) restorePrimedCart(prime);
        self.refreshOpenDrawer();
        if (err && err.fromAdd) window.alert(err.message || 'Could not add items to cart.');
        return;
      }

      markCartTiming('fd-bb:cart-confirmed', markStart);
      if (typeof window.updateCartCount === 'function') window.updateCartCount(cart.item_count);
      // Gift sync, upsells and recommendations fill in after the prices are on screen.
      // Re-read first: a gift sync may have written to the cart while renders were held.
      if (typeof display === 'function') {
        whenIdle(function () {
          readCart()
            .then(function (fresh) {
              return display(fresh);
            })
            .catch(function () {});
        });
      }
    }

    var primeReady = prime && prime.promise ? prime.promise : Promise.resolve();
    var bundleId = (items[0] && items[0].properties && items[0].properties._bundle) || '';
    var attrsSynced = false;

    return primeReady
      .then(function () {
        // The prime already wrote the purchase-mode attribute: skip the add shim's
        // second write of it (checked against the cart after the add, below).
        attrsSynced = !!(prime && prime.ok && prime.subscribe === subscribe);
        return self.postItemsWithRetry(items, attrsSynced ? { headers: { 'X-FD-Cart-Attributes-Synced': '1' } } : null).catch(
          function (err) {
            err.fromAdd = true;
            throw err;
          }
        );
      })
      .then(function () {
        g.qty = {};
        notify(self.groupId);
        setCartSkeletonStatus('pricing');
        return readCart();
      })
      .then(function (cart) {
        var payload = {};
        if (codes.length && !hasAllCodes(cart, codes)) {
          payload.discount = mergeCodes(existingCodesForBox(cart), codes).join(',');
        }
        if (attrsSynced) {
          // Same rule as the add handler: the box is a subscription if any of its
          // paid lines kept a selling plan after the add.
          var wantAttrs = subscriptionAttributes(boxIsSubscription(cart, bundleId, subscribe));
          var haveAttrs = (cart && cart.attributes) || {};
          var attrsOff = Object.keys(wantAttrs).some(function (key) {
            return String(haveAttrs[key] || '') !== wantAttrs[key];
          });
          if (attrsOff) payload.attributes = wantAttrs;
        }
        return Object.keys(payload).length ? writeCart(payload) : cart;
      })
      .then(function (cart) {
        if (typeof display !== 'function') return cart;
        return Promise.resolve(
          display(cart, {
            skipGwpSync: true,
            skipUpsells: true,
            skipRecommendations: true,
            lightCorrections: true,
          })
        ).then(function () {
          return cart;
        });
      })
      .then(function (cart) {
        return linesPainted(cart).then(function () {
          finish(cart, null);
        });
      })
      .catch(function (err) {
        finish(null, err);
      });
  };

  FdBuildBoxPopup.prototype.applyThemeDiscountAndCheckout = function (items) {
    var d = getThemeDiscount();
    var g = getGroup(this.groupId);
    var isSub = g.subscribe !== false;
    var codes = [];
    if (isSub && d.subCode) codes.push(d.subCode);
    if (!isSub && d.otpCode) codes.push(d.otpCode);

    return this.applyDiscountCodes(items).then(function (cart) {
      if (
        window.SubscriptionCheckout &&
        typeof window.SubscriptionCheckout.redirectToCheckout === 'function'
      ) {
        return window.SubscriptionCheckout.redirectToCheckout(cart || undefined);
      }
      if (codes.length) {
        window.location.href =
          '/checkout?discount=' + codes.map(encodeURIComponent).join(',');
        return;
      }
      window.location.href = '/checkout';
    });
  };

  FdBuildBoxPopup.prototype.remapSellingPlans = function (items) {
    var self = this;
    var tasks = items.map(function (item) {
      if (!item.selling_plan) return Promise.resolve(false);
      var product = self.findProduct(item.id);
      var handle = (product && product.handle) || '';
      if (!handle) return Promise.resolve(false);
      return self.getProductSellingPlanIdForVariant(handle, item.id).then(function (fallback) {
        if (!fallback || String(fallback) === String(item.selling_plan)) return false;
        item.selling_plan = fallback;
        if (item.properties) item.properties._if_upgrade__selling_plan_id = String(fallback);
        return true;
      });
    });
    return Promise.all(tasks).then(function (changed) {
      return changed.some(Boolean);
    });
  };

  FdBuildBoxPopup.prototype.postItems = function (items, init) {
    if (typeof window.addToCart === 'function') {
      return window.addToCart({ items: items }, init || {}).then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      });
    }
    var headers = Object.assign(
      { 'Content-Type': 'application/json', Accept: 'application/json' },
      (init && init.headers) || {}
    );
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    });
  };

  // Post the box; on a 422 retry once with each product's own selling plan.
  FdBuildBoxPopup.prototype.postItemsWithRetry = function (items, init) {
    var self = this;
    function failure(result) {
      return new Error(
        (result.data && (result.data.description || result.data.message)) || 'Could not add items to cart.'
      );
    }
    return this.postItems(items, init).then(function (result) {
      if (!result.ok && result.status === 422) {
        return self.remapSellingPlans(items).then(function (changed) {
          if (!changed) throw failure(result);
          return self.postItems(items, init).then(function (retry) {
            if (!retry.ok) throw failure(retry);
            return retry.data;
          });
        });
      }
      if (!result.ok) throw failure(result);
      return result.data;
    });
  };

  FdBuildBoxPopup.prototype.syncDealToEarned = function () {
    var g = getGroup(this.groupId);
    var filled = this.totalQty();
    var earned = earnedGiftTier(g.dealCounts, filled);
    if (!earned) return;

    g.count = earned;

    var qtyEl = document.querySelector(
      '[data-fd-build-box][data-group="' + this.groupId + '"]'
    );
    var qtyInst = qtyEl && qtyEl.__fdBuildBox;
    if (!qtyInst) return;

    Array.prototype.forEach.call(qtyInst.els.deals, function (el) {
      var c = parseInt(el.getAttribute('data-deal-count'), 10) || 0;
      if (c !== earned) return;
      g.dealId = el.getAttribute('data-deal-id');
      var nameEl = el.querySelector('.fd-build-box__deal-name');
      g.dealName = nameEl ? nameEl.textContent.trim() : earned + ' Pack';
    });
  };

  FdBuildBoxPopup.prototype.submit = function (opts) {
    var self = this;
    if (this.state.submitting) return;
    var g = getGroup(this.groupId);
    var filled = this.totalQty();
    if (filled < 1) return;

    if (this.drawerMode && !(opts && opts.skipSheet)) {
      var target = this.state.packTarget || Number(g.count) || 0;
      if (filled < target && this.openSheet()) return;
    }

    this.syncDealToEarned();
    g = getGroup(this.groupId);

    var items = this.buildItems();
    if (!items.length) {
      return;
    }

    this.state.submitting = true;
    this.renderCheckout(g);

    if (this.fastCart) {
      this.state.submitted = true;
      this.close();
      this.submitToDrawer(items);
      return;
    }

    this.postItemsWithRetry(items)
      .then(function () {
        g.qty = {};
        notify(self.groupId);
        return self.applyThemeDiscountAndCheckout(items);
      })
      .catch(function (err) {
        window.alert((err && err.message) || 'Could not add items to cart.');
        self.state.submitting = false;
        self.renderCheckout(getGroup(self.groupId));
      });
  };

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateCount(el) {
    if (!el || el.getAttribute('data-fd-counted') === '1') return;
    var end = parseInt(el.getAttribute('data-fd-count-end'), 10);
    if (!Number.isFinite(end)) return;
    el.setAttribute('data-fd-counted', '1');
    if (prefersReducedMotion()) {
      el.textContent = String(end);
      return;
    }
    var duration = 1400;
    var startAt = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - startAt) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(end * eased));
      if (t < 1) requestAnimationFrame(tick);
    }
    el.textContent = '0';
    requestAnimationFrame(tick);
  }

  function initCountUps(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-fd-count-end]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || prefersReducedMotion()) {
      nodes.forEach(animateCount);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCount(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    var qtyNodes = document.querySelectorAll('[data-fd-build-box]');
    var popupNodes = document.querySelectorAll('[data-fd-build-box-popup]');

    qtyNodes.forEach(function (el) {
      if (el.__fdBuildBox) return;
      el.__fdBuildBox = new FdBuildBoxQty(el);
    });
    popupNodes.forEach(function (el) {
      if (el.__fdBuildBoxPopup) return;
      el.__fdBuildBoxPopup = new FdBuildBoxPopup(el);
    });
    initCountUps(document);
    applyDateTokens(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.FDBuildBox = {
    getGroup: getGroup,
    onGroupChange: onGroupChange,
  };
})();
